import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import PageHeader from "../components/PageHeader";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import {
  SITENAMEALIAS,
  WEBSERVICE,
  ASSETS,
  CAPTCHASITEKEY,
  SITENAME,
} from "../utils/init";
import { useNavigate } from "react-router-dom";
import { render } from "react-dom";
import { Link, withRouter } from "react-router-dom";
import {
  SaveBasicUserSettings,
  SaveTwoFactorSettings,
  FetchUserSettings,
  ChangePassword,
  FetchMerchantSettings,
  SetNotifiEmail,
  EmailCheck,
  FetchMerchantProfile,
  FetchAllIndustry,
  FetchActivatedVolume,
  FetchMerchantStatus,
  UpdateVolumeId,
  UploadFile,
  AddMerchantProfile,
  GetMerchantSettings,
  SetMerchantSettings,
  googleTwoFactorAuth,
  checkTwoFactorAuth,
  getSignUpPhoneOtp,
  verifyRegistredPhoneNo,
  phoneAuthEnable,
  phoneAuthDisable,
  getSignUpEmailOtp,
  sendOtpForTwoFa,
  sendOtpInRegNo,
  checkTwoFactorAuthSettings,
  FetchUsdBtcLedgerAmount,
  PurgeData,
  sendEmailOtpForUpdate,
  updateMerchantEmail,
  ChangeProcessingFeeStatus,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import { Modal, Form, Button } from "react-bootstrap";
import QRCode from "react-qr-code";
import {
  _isValidPhoneNo,
  _isValidZipCode,
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
  formatAmount,
  currentPageAccess,
  showConfirm,
} from "../utils/library";
import axios from "axios";
import CaptchaModal from "./CaptchaModal";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import Swal from "sweetalert2";

class BussinessSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      showCaptchaModal: false,
      showCaptchaModalSecond: false,
      noOfItemsPerPage: 10,
      showAppSettings: true,
      showUserSettings: false,
      isTwoFactorAuthChecked: false,
      qrcodeValue: "",
      qrcode: "",
      isInputQrCodeAvailable: true,
      firstName: "",
      lastName: "",
      phoneNo: "",
      currentPassword: "",
      newPassword: "",
      reTypePassword: "",
      merchantName: "",
      merchantWebsite: "",
      merchantIndustry: "",
      supportPhone: "",
      supportEmail: "",
      dailyTxnLimit: "",
      monthlyTxnLimit: "",
      sendNotificationTo: "",
      showOrderSettingsModal: false,
      showMerchantSettingsModal: false,
      showIncreaseVolumeModal: false,
      showAutomaticExceptionHandlingModal: false,
      googleAuthModal: false,
      isGoogleAuthChecked: false,
      showTaxModal: false,
      sendNotificationToRegisteredAddress: true,
      sendNotificationToDifferentAddress: false,
      newNotificationEmail: "",
      industryList: [],
      currentPlanTxnCharges: [],
      plans: [],
      assets: [],
      selectedIndustryForMerchantEdit: "",
      isPreferedEmailChecked: true,
      isPreferedWebsiteChecked: false,
      isAcceptBtcAtRetailChecked: false,
      isDisplayAddressChecked: false,
      isDifferenAddressChecked: false,
      isLightPlanApplied: false,
      isBasicPlanApplied: false,
      isBusinessPlanApplied: false,
      isEnterprisePlanApplied: false,
      selectedPlanIdForApply: "",
      ein: "",
      einDoc: null,
      ownerIdentityDoc: null,
      inCorpDoc: null,
      businessAddressDoc: null,
      website: "",
      mAddress1: "",
      mAddress2: "",
      mCity: "",
      mState: "",
      mCountry: "",
      mZip: "",
      mOrganizationName: "",
      mDesc: "",
      mIndustry: "",
      mWebsite: "",
      mSupportPhone: "",
      mSupportEmail: "",
      selectedCurrencyIdForAutomaticExceptionHandling: "2",
      isAutomaticAcceptUnderpayment: false,
      underPaymentToleranceLimit: "",
      isAutomaticAcceptOverpayment: false,
      overPaymentToleranceLimit: "",
      showChangePasswordAuthModal: false,
      changePasswordAuthCode: "",
      isChangePswdAuthCodeBtn: true,
      basicSettingCaptchaValue: "",
      isBasicSettingBtnEnable: false,
      securityCaptchaValue: "",
      isSecuritySettingBtnEnabled: false,
      resetPswdCaptchaValue: "",
      savePasswordResetBtnEnabled: false,
      sendOtpBtnForPhnoChange: true,
      isPhoneNumberReadonly: true,
      isChangePhnoBtnDisable: false,
      changePhnoModal: false,
      newPhnoModal: false,
      sendOtpInRegnoBtn: true,
      sendOtpInNewnoBtn: true,
      //for registred otp modal
      timertxt: "",
      secondStatusCheckForOtpTimer: false,
      isTimerShow: false,
      btnProceedToNewNo: false,

      //for new number otp modal
      timertxt2: "",
      secondStatusCheckForNewOtpTimer: false,
      isTimerShow2: false,
      btnUpdateToNewNo: false,

      isPhoneAuthChecked: false,

      isTwoFactorChecked: false,
      showEmailOtpTimer: false,
      emailOtpTimerTxt: "",
      sendEmailOtpBtn: false,
      proceedEmailOtpBtn: true,
      qrCodeValFor2fa: "",
      qrCodeInput: "",
      verifyQrCodeBtn: true,
      scannerModal: false,
      qrcodeval: "",
      googleAuthKey: "",

      sendEmailOtpFor2faBtn: false,
      showTimerForChangPhno: false,
      otptimertxt: false,
      secondStatusCheckForMobileOtpTimer: false,
      sendOtpOldNo: false,
      emailOtpFor2fa: "",
      emailOtpFor2faRefError: "",

      // Email Update states
      currentEmailForUpdate: "",
      newEmailForUpdate: "",
      emailUpdateOtpModal: false,
      oldEmailOtp: "",
      newEmailOtp: "",
      sendOtpOldEmailBtn: false,
      showOldEmailOtpTimer: false,
      oldEmailOtpTimerTxt: "",
      newEmailError: "",

      orgNameError: false,
      btnUpdateSetting: false,
      descriptionError: false,
      websiteError: false,
      phoneError: false,
      emailIdError: false,
      address1_error: false,
      address2_error: false,
      cityError: false,
      stateError: false,
      zipcodeError: false,

      registeredPhnoOtp: "",
      captcha: "",
      sessionId: "",
      showCaptchaModalDelete: false,
      apiKeyDiv: true,
      Themecolor: "Dark", // or 'Light'
      apitype: [],
      apikey: "",
      secretkey: "",
      apikeylist: [],
      settingsObj: { name: "" },
      ipRestrictStatus: 0,
      ipListTemp: [],
      apiKeyDataForEdit: null,
      gaOtpForEdit: "",
      emailOtpForEdit: "",
      isGetCodeButtonDisabled: false,
      createApiOtpCountdown: 60,
      messageotp: "",
      deleteapikeyObj: {},
      gaOtpForDelete: "",
      emailOtpForDelete: "",

      twoFactorAPIKeyModal: false,
      newAPIKeyName: "",

      apiKey: "abc123xyz456",
      apiSecret: "secret789xyz321",
      permissions: {
        Read: true,
        Dashboard: false,
        "Payment Button": false,
        "RECURRING PAYMENT": false,
        "EMAIL BILLING": false,
        "HOSTED CATALOG": false,
        INSIGHTS: false,
      },

      showEditModal: false,
      selectedApiKey: null,
      ipRestrictStatus: 0,
      ipListTemp: [],
      twoFactorAPIKeyModalStatus: "",
      newApiKeyGen: "",
      newApiSecretKeyGen: "",
      deletePayload: {},

      // Processing Fee Handling
      processingFeeHandling: "customer", // 1 for 'customer' or 0 for 'merchant'
    };

    this.firstNameRef = React.createRef;
    this.lastNameRef = React.createRef;
    this.phoneRef = React.createRef;
    this.qrCodeValueRef = React.createRef();
    this.changePasswordAuthCodeRef = React.createRef();
    this.basicSettingRecaptchaRef = React.createRef();
    this.securitySettingRecaptchaRef = React.createRef();
    this.passwordChangeRecaptchaRef = React.createRef();
    this.deleteRecaptchaRef = React.createRef();
    this.registeredPhnoOtpRef = React.createRef();
    this.newPhnoOtpRef = React.createRef();
    this.googleAuthOtpRef = React.createRef();
    this.emailOtpFor2faRef = React.createRef();
    this.oldEmailOtpRef = React.createRef();
    this.newEmailOtpRef = React.createRef();
    this.twofaqrcodevalue = React.createRef();
    this.emailOtpForTwoFaOff = React.createRef();
    this.gaCodeFor2faOff = React.createRef();
    this.copyTxtRef = React.createRef();
  }

  /* Method defination for toggling settings */
  handleSettingsToggle = (param) => {
    if (param == "user") {
      this.setState({
        showUserSettings: true,
        showAppSettings: false,
      });
      this.renderUserSettingsData();
    } else {
      this.setState({
        showUserSettings: false,
        showAppSettings: true,
      });
      this.renderMerchantSettings();
    }
  };

  /* Method defination for retrieving merchant status */
  getMerchantStatus = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchMerchantStatus(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Order Settings Updated Successfully");
            this.renderMerchantSettings();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for checking email */
  handleCheckEmail = (e) => {
    if (e.target.value != "") {
      let payload = {
        email: e.target.value,
      };
      this.setState({ showLoader: true });
      EmailCheck(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              this.setState(
                {
                  newNotificationEmail: "",
                },
                () => {
                  showToast("error", response.error_msg);
                  e.target.value = "";
                }
              );
            } else {
              this.setState({
                newNotificationEmail: e.target.value,
              });
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            console.log("err", err);
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  /* Method defination for updating order settings */
  handleUpdateOrderSetting = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    if (this.state.sendNotificationToDifferentAddress) {
      console.log("IF ", this.state.newNotificationEmail);
      payload.notification_email = this.state.newNotificationEmail;
    } else {
      console.log("ELSE ", this.state.sendNotificationTo);
      payload.notification_email = this.state.sendNotificationTo;
    }
    this.setState({ showLoader: true });
    SetNotifiEmail(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Order Settings Updated Successfully");
            this.renderMerchantSettings();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for change password API call */
  handleChangePassword = async () => {
    if (
      this.state.currentPassword != "" &&
      this.state.newPassword != "" &&
      this.state.reTypePassword != ""
    ) {
      try {
        const { token } = await this.passwordChangeRecaptchaRef.current.verify();
        this.handleCaptchaSubmitSecond(token);
      } catch (err) {
        showToast("error", err.message || "Captcha verification failed");
      }
    } else {
      showToast(
        "error",
        "Please provide current,new and retype password field data"
      );
    }
  };
  handleCaptchaSubmitSecond = (captcha) => {
    this.setState({ captcha: captcha });
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        showChangePasswordAuthModal: true,
      });
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  setStateHandler = (newState) => {
    this.setState(newState);
  };
  handleDeleteMyData = async () => {
    try {
      const { token } = await this.deleteRecaptchaRef.current.verify();
      this.handleCaptchaSubmitDelete(token);
    } catch (err) {
      showToast("error", err.message || "Captcha verification failed");
    }
  };

  handleCaptchaSubmitDelete = (captcha) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete your data?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, I want to delete",
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: "Confirm",
          text: "This process is irreversible. If you choose to proceed with this your data will be permanently deleted and you will lose access to your account immediately. Are you sure you wish to proceed?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Delete my data",
        }).then((result) => {
          if (result.value) {
            let payload = {
              merchant_uuid: getAuthUuid(),
              gRecaptchaResponse: captcha,
            };
            this.setState({ showLoader: true });
            PurgeData(payload).then(
              function (res) {
                let response = res.data[0];
                if (response.error != "0") {
                  showToast("error", response.error_msg);
                } else {
                  showToast("success", response.error_msg);
                  this.handleLogout();
                }
              }.bind(this)
            );
          }
        });
      }
    });
  };

  isPasswordAuthCheck = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      current_password: this.state.currentPassword,
      new_password: this.state.newPassword,
      gRecaptchaResponse: this.state.captcha,
    };
    if (this.state.changePasswordAuthCode != "") {
      payload["google_factor_otp"] =
        this.changePasswordAuthCodeRef.current.value;
      ChangePassword(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", "Password changed successfully");
              this.setState({
                currentPassword: "",
                newPassword: "",
                reTypePassword: "",
                changePasswordAuthCode: "",
                showChangePasswordAuthModal: false,
              });
              window.location.reload();
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            console.log("err", err);
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  /* Method defination for rendering user settings data */
  renderUserSettingsData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUserSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.setState({
              firstName: response.first_name,
              lastName: response.last_name,
              phoneNo: response.phone_no,
              currentPassword: "",
            });
            localStorage.setItem(
              SITENAMEALIAS + "_registredphno",
              response.phone_no
            );
            localStorage.setItem("exit_2fa_key", response.EXIST_2FA_KEY);

            if (response.google_auth_enabled == "0") {
              this.setState({
                isTwoFactorChecked: false,
              });
            } else {
              this.setState({
                isTwoFactorChecked: true,
              });
            }
            if (response.phone_auth_enabled == "0") {
              this.setState({
                isPhoneAuthChecked: false,
              });
            } else {
              this.setState({
                isPhoneAuthChecked: true,
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };
  /* Method defination for rendering merchant settings */
  renderMerchantSettings = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let processingFeesType = response.is_processing_fee_enabled;
            let currentPlanTxnCharges = response.TXN_CHARGES;
            let txnChargesArr = currentPlanTxnCharges.split(",");
            let txnChargeList = [];
            for (let i = 0; i < txnChargesArr.length; i++) {
              let iter = txnChargesArr[i];
              let iterArr = iter.trim().split(" ");
              let obj = { asset: iterArr[0], charge: iterArr[1] };
              txnChargeList.push(obj);
            }
            this.setState({
              currentPlanTxnCharges: txnChargeList,
              plans: response.plans,
              processingFeeHandling:
                parseInt(processingFeesType) === 1 ? "customer" : "merchant",
              merchantWebsite: response.website,
              merchantName: response.organization_name,
              merchantIndustry: response.industry_name,
              supportEmail: response.support_email,
              supportPhone: response.support_phone,
              sendNotificationTo: response.notification_email,
              dailyTxnLimit: response.daily_amount_cap,
              monthlyTxnLimit: response.monthly_transaction_cap,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log("err", err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method Defination for saving user settings */
  handleSaveBasicUserSettings = async () => {
    if (
      this.state.firstName != "" &&
      this.state.lastName != "" &&
      this.state.phoneNo != ""
    ) {
      try {
        const { token } = await this.basicSettingRecaptchaRef.current.verify();
        this.handleCaptchaSubmit(token);
      } catch (err) {
        showToast("error", err.message || "Captcha verification failed");
      }
    } else {
      showToast("error", "Please provide first name, last name and phone no.");
    }
  };

  handleCaptchaSubmit = (captcha) => {
    let payload = {
      merchant_f_name: this.state.firstName,
      merchant_l_name: this.state.lastName,
      phone: this.state.phoneNo,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      gRecaptchaResponse: captcha,
    };
    SaveBasicUserSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            this.renderUserSettingsData();
            this.setState({
              isBasicSettingBtnEnable: true,
            });
            showToast("success", "Settings saved successfully");
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  setStateHandler = (newState) => {
    this.setState(newState);
  };

  handleLogout = () => {
    localStorage.removeItem(SITENAMEALIAS + "_merchant_id");
    localStorage.removeItem(SITENAMEALIAS + "_first_name");
    localStorage.removeItem(SITENAMEALIAS + "_last_name");
    localStorage.removeItem(SITENAMEALIAS + "_email");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_userid");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_id");
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  //  COPY TEXT TO CLIPBOARD
  copyTextToClipboard = () => {
    const textToCopy = this.copyTxtRef.current.innerText;
    navigator.clipboard.writeText(textToCopy);
  };
  /* Method defination for getting all merchant data */
  renderMerchantProfileData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchMerchantProfile(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            console.log(response);
            this.setState({
              selectedIndustryForMerchantEdit: response.industry_id,
              mOrganizationName: response.organization_name,
              mDesc: response.organization_desc,
              mWebsite: response.website,
              mSupportPhone: response.support_phone
                ? response.support_phone.replace(/\D/g, "")
                : "",
              mSupportEmail: response.support_email,
              mAddress1: response.inv_address_line_1,
              mAddress2: response.inv_address_line_2,
              mCity: response.inv_city,
              mState: response.inv_state,
              mCountry: response.inv_country,
              mZip: response.inv_zip,
            });

            if (response.display_address_on_bill == 0) {
              this.setState({
                isDisplayAddressChecked: false,
              });
            } else {
              this.setState({
                isDisplayAddressChecked: true,
              });
            }

            if (response.separate_invoice_location == 0) {
              this.setState({
                isDifferenAddressChecked: false,
              });
            } else {
              this.setState({
                isDifferenAddressChecked: true,
              });
            }

            console.log("retail locationo:", response.bitcoin_retail_location);
            if (response.bitcoin_retail_location == "0") {
              this.setState({
                isAcceptBtcAtRetailChecked: false,
              });
            } else {
              this.setState({
                isAcceptBtcAtRetailChecked: true,
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for fetch activated volume data */
  renderActivatedVolumeData = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchActivatedVolume(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error && response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response.volume_id == "1") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Light Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: true,
                  isBasicPlanApplied: false,
                  isBusinessPlanApplied: false,
                });
              }
            } else if (response.volume_id == "2") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Basic Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: false,
                  isBasicPlanApplied: true,
                  isBusinessPlanApplied: false,
                });
              }
            } else if (response.volume_id == "3") {
              if (response.requested_volume_status == "33") {
                showToast(
                  "error",
                  "Your volume change request to Business Plan has been declined by admin."
                );
              } else {
                this.setState({
                  isLightPlanApplied: false,
                  isBasicPlanApplied: false,
                  isBusinessPlanApplied: true,
                });
              }
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          console.log(err);
          showHttpError(err);
        }.bind(this)
      );
  };

  handleOrgName = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{2,50}$/;
    if (regex.test(elm)) {
      this.setState({
        orgNameError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        orgNameError: true,
        btnUpdateSetting: true,
        mOrganizationName: "",
      });
    }
  };

  handleDiscription = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{2,50}$/;
    if (regex.test(elm)) {
      this.setState({
        descriptionError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        descriptionError: true,
        btnUpdateSetting: true,
        mDesc: "",
      });
    }
  };

  handleWebsite = (e) => {
    let elm = e.target.value;
    let regex =
      /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9#?=&\/_-]+)*$/;
    if (regex.test(elm)) {
      this.setState({
        websiteError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        websiteError: true,
        btnUpdateSetting: true,
        mWebsite: "",
      });
    }
  };
  isValidWebsite = (e) => {
    let elm = e.target.value;
    let regex =
      /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9_-]+\.[a-zA-Z]{2,}(?:\/[a-zA-Z0-9#?=&\/_-]+)*$/;
    if (regex.test(elm)) {
      this.setState({
        isWebsiteError: false,
        btnDisabled: false,
      });
    } else {
      this.setState({
        isWebsiteError: true,
        btnDisabled: true,
        website: "",
      });
    }
  };

  handlePhoneNumber = (e) => {
    let elm = e.target.value;
    let regex = /^(\+)?\d{1,15}$/;
    if (regex.test(elm)) {
      this.setState({
        phoneError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        phoneError: true,
        btnUpdateSetting: true,
        mSupportPhone: "",
      });
    }
  };
  handleEmailId = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9._%+-]{1,30}@[a-zA-Z0-9-]{1,30}\.[a-zA-Z]{2,}$/;
    if (regex.test(elm)) {
      this.setState({
        emailIdError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        emailIdError: true,
        btnUpdateSetting: true,
        mSupportEmail: "",
      });
    }
  };

  handleAddress1 = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(elm)) {
      this.setState({
        address1_error: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        address1_error: true,
        btnUpdateSetting: true,
        mAddress1: "",
      });
    }
  };

  handleAddress2 = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9\s\/\.,-]+$/;
    if (regex.test(elm)) {
      this.setState({
        address2_error: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        address2_error: true,
        btnUpdateSetting: true,
        mAddress2: "",
      });
    }
  };

  handleCity = (e) => {
    let elm = e.target.value;
    let regex = /^[A-Za-z ]+$/;
    if (regex.test(elm)) {
      this.setState({
        cityError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        cityError: true,
        btnUpdateSetting: true,
        mCity: "",
      });
    }
  };

  handleState = (e) => {
    let elm = e.target.value;
    let regex = /^[A-Za-z ]+$/;
    if (regex.test(elm)) {
      this.setState({
        stateError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        stateError: true,
        btnUpdateSetting: true,
        mState: "",
      });
    }
  };

  handleZipcode = (e) => {
    let elm = e.target.value;
    let regex = /^[a-zA-Z0-9 ]{1,15}$/;
    if (regex.test(elm)) {
      this.setState({
        stateError: false,
        btnUpdateSetting: false,
      });
    } else {
      this.setState({
        stateError: true,
        btnUpdateSetting: true,
        mZip: "",
      });
    }
  };

  /* Method defination for handling update merchant profile settings data */
  handleUpdateMerchantProfileSettings = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      organization_name: this.state.mOrganizationName,
      organization_desc: this.state.mDesc,
      industry_id: this.state.selectedIndustryForMerchantEdit,
      website: this.state.mWebsite,
      support_phone: this.state.mSupportPhone,
      support_email: this.state.mSupportEmail,
    };

    if (this.state.isPreferedEmailChecked) {
      payload["preffered_contact_method"] = "email";
    } else {
      payload["preffered_contact_method"] = "website";
    }
    if (this.state.isAcceptBtcAtRetailChecked == true) {
      payload["bitcoin_retail_location"] = "1";
    } else {
      payload["bitcoin_retail_location"] = "0";
    }
    if (this.state.isDisplayAddressChecked == true) {
      payload["display_address_on_bill"] = 1;
    } else {
      payload["display_address_on_bill"] = 0;
    }
    if (
      this.state.isDifferenAddressChecked == true &&
      this.state.mAddress1 != "" &&
      this.state.mCity != "" &&
      this.state.mState != "" &&
      this.state.mZip != "" &&
      this.state.mCountry != ""
    ) {
      payload["separate_invoice_location"] = 1;
      payload["inv_address_line_1"] = this.state.mAddress1;
      payload["inv_address_line_2"] = this.state.mAddress2;
      payload["inv_city"] = this.state.mCity;
      payload["inv_state"] = this.state.mState;
      payload["inv_country"] = this.state.mCountry;
      payload["inv_zip"] = this.state.mZip;
    } else {
      payload["separate_invoice_location"] = 0;
      payload["inv_address_line_1"] = "";
      payload["inv_address_line_2"] = "";
      payload["inv_city"] = "";
      payload["inv_state"] = "";
      payload["inv_country"] = "";
      payload["inv_zip"] = "";
    }
    this.setState({ showLoader: true });
    AddMerchantProfile(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Details updated successfully");
            this.setState({ showMerchantSettingsModal: false }, () => {
              this.renderMerchantProfileData();
              this.renderMerchantSettings();
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };
  /* Method defination for fetching all industry */
  renderAllIndustry = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchAllIndustry(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          this.setState({
            industryList: response,
          });
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  /* Method defination for applying a plan */
  handleApplyPlan = () => {
    console.log(this.state.ein, this.state.einDoc);
    if (this.state.ein != "" && this.state.einDoc != null) {
      let fd = new FormData();
      fd.append("file_1", this.state.einDoc);
      fd.append("file_type_1", 1);
      fd.append("file_2", this.state.ownerIdentityDoc);
      fd.append("file_type_2", 3);
      fd.append("file_3", this.state.businessAddressDoc);
      fd.append("file_type_3", 4);
      fd.append("file_4", this.state.inCorpDoc);
      fd.append("file_type_4", 5);
      fd.append(
        "merchant_id",
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      );
      this.setState({ showLoader: true });

      UploadFile(fd)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              let payload = {
                merchant_id: localStorage.getItem(
                  SITENAMEALIAS + "_merchant_id"
                ),
                volume_id: this.state.selectedPlanIdForApply,
                tax_id: this.state.ein,
                website: this.state.website,
              };

              this.setState({ showLoader: true });

              UpdateVolumeId(payload)
                .then(
                  function (res) {
                    this.setState({ showLoader: false });
                    let response = res.data[0];
                    if (response.error != "0") {
                      showToast("error", response.error_msg);
                    } else {
                      showToast("success", "Plan applied successfully");
                      setTimeout(() => {
                        window.location.reload();
                      }, 3000);
                    }
                  }.bind(this)
                )
                .catch(
                  function (err) {
                    this.setState({ showLoader: false });
                    showHttpError(err);
                  }.bind(this)
                );
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "Please provide valid EIN and EIN document");
    }
  };

  /* Method defination for rendering settings for automatic exception handling */
  renderSettingsForAutomaticExceptionHandling = (currencyId) => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: currencyId,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            let acceptOverPayment = false;
            let acceptUnderPayment = false;
            if (
              response.accept_overpayments != "" &&
              response.accept_overpayments != null &&
              response.accept_overpayments != "no"
            ) {
              acceptOverPayment = true;
            } else {
              acceptOverPayment = false;
            }
            if (
              response.accept_underpayments != "" &&
              response.accept_underpayments != null &&
              response.accept_underpayments != "no"
            ) {
              acceptUnderPayment = true;
            } else {
              acceptUnderPayment = false;
            }
            this.setState({
              underPaymentToleranceLimit: formatAmount(
                response.underpayment_tolerance,
                5
              ),
              overPaymentToleranceLimit: formatAmount(
                response.overpayment_tolerance,
                5
              ),
              isAutomaticAcceptOverpayment: acceptOverPayment,
              isAutomaticAcceptUnderpayment: acceptUnderPayment,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  /*  */
  handleUpdateProcessingFeeStatus = async () => {
    ChangeProcessingFeeStatus(
      localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      this.state.processingFeeHandling === "customer" ? 1 : 0
    )
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          if (!response.status) {
            showToast("error", response.data);
          } else {
            this.renderMerchantSettings();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
    showToast("success", "Processing fee preference saved successfully");
  };

  /* Method defination for saving automatic exception handling data */
  handleAutomaticExceptionHandling = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: this.state.selectedCurrencyIdForAutomaticExceptionHandling,
      overpayment_tolerance: formatAmount(
        this.state.overPaymentToleranceLimit,
        5
      ),
      underpayment_tolerance: formatAmount(
        this.state.underPaymentToleranceLimit,
        5
      ),
    };
    if (this.state.isAutomaticAcceptUnderpayment) {
      payload["accept_underpayments"] = "yes";
    } else {
      payload["accept_underpayments"] = "no";
    }
    if (this.state.isAutomaticAcceptOverpayment) {
      payload["accept_overpayments"] = "yes";
    } else {
      payload["accept_overpayments"] = "no";
    }

    this.setState({ showLoader: true });
    SetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.setState(
              {
                showAutomaticExceptionHandlingModal: false,
              },
              () => {
                showToast(
                  "success",
                  "Automatic Exceptional Handling data saved successfully"
                );
              }
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleOnCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        basicSettingCaptchaValue: value,
      },
      () => {
        this.setState({
          isBasicSettingBtnEnable: true,
        });
      }
    );
  };

  onSecureCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        securityCaptchaValue: value,
      },
      () => {
        this.setState({
          isSecuritySettingBtnEnabled: true,
        });
      }
    );
  };
  onPswdCaptchaChange = (value) => {
    console.log("Captcha Value", value);
    this.setState(
      {
        resetPswdCaptchaValue: value,
      },
      () => {
        this.setState({
          savePasswordResetBtnEnabled: true,
        });
      }
    );
  };
  getTwoFactorAuthVerify = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };

    if (this.state.isGoogleAuthChecked == false) {
      googleTwoFactorAuth(payload)
        .then(
          function (res) {
            var response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              console.log(response.google_auth_key);
              var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
              var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
              var twoFactorAuthKey =
                "otpauth://totp/" +
                _issuer + ":" + _email +
                "?secret=" +
                response.google_auth_key +
                "&issuer=" +
                _issuer;
              this.setState({
                googleAuthModal: true,
                qrcodeValue: twoFactorAuthKey,
                isGoogleAuthChecked: true,
                googleAuthKey: response.google_auth_key,
              });
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      this.setState({
        isGoogleAuthChecked: false,
      });
    }
  };

  getTwoFactorAuthVerifcation = () => {
    if (this.twofaqrcodevalue.current.value != "") {
      let payload = {
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        google_auth_enabled: "1",
        google_factor_otp: this.twofaqrcodevalue.current.value,
      };

      SaveTwoFactorSettings(payload).then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.handleLogout();
          }
        }.bind(this)
      );
    } else {
      this.setState({
        isGoogleAuthChecked: false,
      });
    }
  };

  googleAuthOtpVerification = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      otp: this.qrCodeValueRef.current.value,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    checkTwoFactorAuthSettings(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            console.log("not working");
            showToast("error", response.error_msg);
            this.setState({
              googleAuthModal: false,
              isGoogleAuthChecked: false,
            });
            window.location.reload();
          } else {
            console.log("working");
            showToast("success", "Google authentication updated successfully");
            this.setState({
              googleAuthModal: false,
              isGoogleAuthChecked: true,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  clearPhnoForEdit = () => {
    this.setState({
      phoneNo: "",
      isPhoneNumberReadonly: false,
      isChangePhnoBtnDisable: true,
    });
  };

  sendOtp = () => {
    this.setState({
      changePhnoModal: true,
    });
    this.sendOtpToRegisteredPhno();
    localStorage.setItem("secondStatusCheckForOtpTimer", "true");
    let count = "120";
    localStorage.setItem("cdotpforchangephno", count);
    this.startTimeForChangePhno(count);
  };

  sendOtpToRegNo = () => {
    this.sendOtpToRegisteredPhno();
    localStorage.setItem("secondStatusCheckForOtpTimer", "true");
    let count = "120";
    localStorage.setItem("cdotpforchangephno", count);
    this.startTimeForChangePhno(count);
  };

  sendOtpToNewNo = () => {
    this.sendOtpToNewInsertedPhno();
    localStorage.setItem("secondStatusCheckForNewOtpTimer", "true");
    let count = "120";
    localStorage.setItem("cdotpfornewphno", count);
    this.startTimeForNewPhno(count);
  };

  verifyChangeNo = (e) => {
    e.preventDefault();
    if (this.registeredPhnoOtpRef.current.value != "") {
      let payload = {
        phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
        phone_otp: this.registeredPhnoOtpRef.current.value,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      verifyRegistredPhoneNo(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.success);
              this.sendOtpToNewNo();
              this.setState({
                newPhnoModal: true,
                changePhnoModal: false,
              });
              localStorage.setItem("cdotpforchangephno", "");
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  submit2faEmailOtp = (e) => {
    e.preventDefault();
    if (this.emailOtpFor2faRef.current.value != "") {
      let payload = {
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        email_otp: this.emailOtpFor2faRef.current.value,
      };
      googleTwoFactorAuth(payload).then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            console.log(response.google_auth_key);
            var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
            var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
            var twoFactorAuthKey =
              "otpauth://totp/" +
              _issuer + ":" + _email +
              "?secret=" +
              response.google_auth_key +
              "&issuer=" +
              _issuer;
            this.setState({
              scannerModal: true,
              qrCodeValFor2fa: twoFactorAuthKey,
              isTwoFactorChecked: true,
              googleAuthKey: response.google_auth_key,
            });
            localStorage.setItem("cdotpforemail2fa", "");
          }
        }.bind(this)
      );
    }
  };

  /* Method defination for getting plans details */
  getPlanDetails = (planName) => {
    let plans = this.state.plans;
    let plan = {};
    for (let i = 0; i < plans.length; i++) {
      if (planName == plans[i].volume_name) {
        plan = plans[i];
        break;
      }
    }
    return plan;
  };

  updateNewNo = (e) => {
    e.preventDefault();
    if (this.newPhnoOtpRef.current.value != "") {
      let payload = {
        newPhone: this.state.phoneNo,
        temp_phone_otp: this.newPhnoOtpRef.current.value,
        phone_otp: this.state.registeredPhnoOtp,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      verifyRegistredPhoneNo(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.error_msg);
              localStorage.setItem(
                SITENAMEALIAS + "_phoneno",
                this.state.phoneNo
              );
              localStorage.setItem("cdotpfornewphno", "");
              window.location.reload();
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  sendOtpToRegisteredPhno = () => {
    let payload = {
      phone: localStorage.getItem(SITENAMEALIAS + "_registredphno"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpInRegNo(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              changePhnoModal: true,
              showTimerForChangPhno: true,
              sendOtpOldNo: true,
              btnProceedToNewNo: false,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  sendOtpToNewInsertedPhno = () => {
    let payload = {
      newPhone: this.state.phoneNo,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpInRegNo(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              isTimerShow2: true,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  startTimeForChangePhno = (i) => {
    let count = i;
    this.setState({ otptimertxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForMobileOtpTimer: false,
            showTimerForChangPhno: false,
            btnProceedToNewNo: true,
          });
          localStorage.setItem("secondStatusCheckForOtpTimer", "false");
          this.state.sendOtpOldNo = false;
        }
        count -= 1;
        localStorage.setItem("cdotpforchangephno", count);
        this.setState({
          otptimertxt: localStorage.getItem("cdotpforchangephno"),
        });
      }, 1000);
    });
  };

  startTimeForNewPhno = (i) => {
    let count = i;
    this.setState({ timertxt2: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secondStatusCheckForNewOtpTimer: false,
            isTimerShow2: false,
            btnUpdateToNewNo: true,
          });
          localStorage.setItem("secondStatusCheckForNewOtpTimer", "false");
          this.state.sendOtpInNewnoBtn = false;
        }
        count -= 1;
        localStorage.setItem("cdotpfornewphno", count);
        this.setState({
          timertxt2: localStorage.getItem("cdotpfornewphno"),
        });
      }, 1000);
    });
  };

  startTimerForEmailOtp = (i) => {
    let count = i;
    this.setState({ emailOtpTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            secstatuscheckForEmailOtpTimer: false,
            showEmailOtpTimer: false,
            proceedEmailOtpBtn: true,
            sendEmailOtpFor2faBtn: false,
          });
          localStorage.setItem("secstatuscheckForEmailOtpTimer", "false");
          this.state.sendEmailOtpBtn = false;
        }
        count -= 1;
        localStorage.setItem("cdotpforemail2fa", count);
        this.setState({
          emailOtpTimerTxt: localStorage.getItem("cdotpforemail2fa"),
        });
      }, 1000);
    });
  };

  // ========== EMAIL UPDATE METHODS ==========

  handleEmailUpdateClick = () => {
    let newEmail = this.state.newEmailForUpdate.trim();
    let currentEmail = localStorage.getItem(SITENAMEALIAS + "_email");

    if (newEmail === "") {
      showToast("error", "Please enter new email");
      return;
    }

    let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      showToast("error", "Please enter a valid new email address");
      return;
    }

    if (currentEmail === newEmail) {
      showToast("error", "New email must be different from current email");
      return;
    }

    this.sendEmailUpdateOtp();
  };

  sendEmailUpdateOtp = () => {
    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
    };
    this.setState({ showLoader: true });
    sendEmailOtpForUpdate(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          console.log("ressss", res);
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              emailUpdateOtpModal: true,
              sendOtpOldEmailBtn: true,
              showOldEmailOtpTimer: true,
            });
            let count = "120";
            localStorage.setItem("cdotpforemailupdate", count);
            this.startTimerForEmailUpdate(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  resendEmailUpdateOtp = () => {
    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
    };
    sendEmailOtpForUpdate(payload)
      .then(
        function (res) {
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", response.error_msg);
            this.setState({
              sendOtpOldEmailBtn: true,
              showOldEmailOtpTimer: true,
            });
            let count = "120";
            localStorage.setItem("cdotpforemailupdate", count);
            this.startTimerForEmailUpdate(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  submitEmailUpdateOtp = (e) => {
    e.preventDefault();
    let oldOtp = this.oldEmailOtpRef.current.value;
    let newOtp = this.newEmailOtpRef.current.value;

    if (oldOtp === "") {
      showToast("error", "Please enter OTP from current email");
      return;
    }
    if (newOtp === "") {
      showToast("error", "Please enter OTP from new email");
      return;
    }

    let payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      oldEmail: localStorage.getItem(SITENAMEALIAS + "_email"),
      newEmail: this.state.newEmailForUpdate.trim(),
      oldEmailOtp: oldOtp,
      newEmailOtp: newOtp,
    };
    this.setState({ showLoader: true });
    updateMerchantEmail(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "success",
              response.error_msg || "Email updated successfully"
            );
            localStorage.setItem(
              SITENAMEALIAS + "_email",
              this.state.newEmailForUpdate.trim()
            );
            localStorage.setItem("cdotpforemailupdate", "");
            this.setState({
              emailUpdateOtpModal: false,
              currentEmailForUpdate: "",
              newEmailForUpdate: "",
            });
            window.location.reload();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  startTimerForEmailUpdate = (i) => {
    let count = i;
    this.setState({ oldEmailOtpTimerTxt: count }, () => {
      let downloadTimer = setInterval(() => {
        if (count <= 1) {
          clearInterval(downloadTimer);
          this.setState({
            showOldEmailOtpTimer: false,
            sendOtpOldEmailBtn: false,
          });
          localStorage.setItem("cdotpforemailupdate", "");
        }
        count -= 1;
        localStorage.setItem("cdotpforemailupdate", count);
        this.setState({
          oldEmailOtpTimerTxt: localStorage.getItem("cdotpforemailupdate"),
        });
      }, 1000);
    });
  };

  // ========== END EMAIL UPDATE METHODS ==========

  phoneSmsAuth = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    if (this.state.isPhoneAuthChecked == false) {
      this.setState({
        isPhoneAuthChecked: true,
      });
      payload["phone_auth_enabled"] = "1";

      phoneAuthEnable(payload)
        .then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              this.handleLogout();
              showToast("success", response.error_msg);
              localStorage.setItem("userSmsAuth", "1");
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    } else {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "0"
      ) {
        showToast(
          "error",
          "Please turn on google authentication from settings."
        );
      } else {
        this.setState({
          showVerifyOtpModalWhilePhoneAuthDisable: true,
        });
      }
    }
  };

  googleAuthVerify = (e) => {
    e.preventDefault();
    if (this.googleAuthOtpRef.current.value != "") {
      let payload = {
        phone_auth_enabled: 0,
        otp: this.googleAuthOtpRef.current.value,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };

      phoneAuthDisable(payload)
        .then(
          function (res) {
            let response = res.data[0];

            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              this.setState({
                isPhoneAuthChecked: false,
              });
              this.handleLogout();
              showToast("success", response.error_msg);
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    }
  };

  checkTwoFactorOnOff = () => {
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
    ) {
      this.setState({
        twoFactorDisableModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      if (localStorage.getItem("exit_2fa_key") == "0") {
        this.setState({
          twoFaSendEmailOtpModal: true,
        });
      } else {
        if (
          localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
        ) {
          this.setState({
            twoFactorDisableModal: true,
          });
          this.sendEmailFor2fa();
        } else {
          this.setState({
            twoFactorDisableModal: true,
          });
          this.sendEmailFor2fa();
        }
      }
    }
  };

  saveTwoFactorSettingOff = (e) => {
    e.preventDefault();
    if (
      this.emailOtpForTwoFaOff.current.value != "" &&
      this.gaCodeFor2faOff.current.value != ""
    ) {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "0"
      ) {
        let payload = {
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          email_otp: this.emailOtpForTwoFaOff.current.value,
        };
        googleTwoFactorAuth(payload).then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              var _email = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_email"));
              var _issuer = encodeURIComponent(localStorage.getItem(SITENAMEALIAS + "_exchange"));
              var twoFactorAuthKey =
                "otpauth://totp/" +
                _issuer + ":" + _email +
                "?secret=" +
                response.google_auth_key +
                "&issuer=" +
                _issuer;
              this.setState({
                scannerModal: true,
                qrCodeValFor2fa: twoFactorAuthKey,
                googleAuthKey: response.google_auth_key,
              });
              localStorage.setItem("cdotpforemail2fa", "");
            }
          }.bind(this)
        );
      }

      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") == "1"
      ) {
        let payload = {
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
          google_auth_enabled: "0",
          google_factor_otp: this.gaCodeFor2faOff.current.value,
          email_otp: this.emailOtpForTwoFaOff.current.value,
        };
        SaveTwoFactorSettings(payload).then(
          function (res) {
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", response.error_msg);
              this.handleLogout();
            }
          }.bind(this)
        );
      }
    }
  };

  sendEmailFor2fa = () => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    sendOtpForTwoFa(payload)
      .then(
        function (res) {
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Otp send to your given email");
            this.setState({
              showEmailOtpTimer: !this.state.showEmailOtpTimer,
              proceedEmailOtpBtn: false,
              sendEmailOtpFor2faBtn: true,
            });
            localStorage.setItem("secstatuscheckForEmailOtpTimer", "true");
            let count = "120";
            localStorage.setItem("cdotpforemail2fa", count);
            this.startTimerForEmailOtp(count);
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  showHiddenNumber = () => {
    let phone = localStorage.getItem(SITENAMEALIAS + "_phoneno");
    this.state.result = "";
    if (phone != undefined && phone != null) {
      for (let i = 0; i < phone.length; i++) {
        if (i > 3 && i <= 8) {
          this.state.result += "*";
        } else {
          this.state.result += phone[i];
        }
      }
      return this.state.result;
    }
  };

  handleRenderAssets = () => {
    console.log("Rendering Asset");
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });

    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          console.log(response);
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }

              const currencyOrder = [
                "USDC",
                "USDT",
                "XRP",
                "DOGE",
                "HCX",
                "ETH",
                "BTC",
                "LTC",
                "BCH",
              ];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState(
                {
                  assets: arr,
                },
                () => {
                  console.log(this.state.assets);
                  localStorage.setItem(
                    SITENAMEALIAS + "_assets",
                    JSON.stringify(this.state.assets)
                  );
                }
              );
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  allApiTypeKey = () => {
    axios
      .get(`${WEBSERVICE}/apiKey/allApiType`, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },      })
      .then((response) => {
        let apitype = response.data.apiTypeList;
        this.setState({ apitype });
      })
      .catch((error) => {
        console.error("Error fetching API types:", error);
      });
  };

  getApiKeyList = () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();

    axios
      .post(
        `${WEBSERVICE}/apiKey/getUserWiseApiKeyDetails`,
        {
          merchant_id,
          merchant_uuid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },        }
      )
      .then((response) => {
        this.setState({ apikeylist: response.data.api_keys });
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  createAPIkey = () => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();
    const keyName = this.state.newAPIKeyName;
    const securityCode = this.gaCodeFor2faOff.current.value;
    const emailOtp = this.emailOtpForTwoFaOff.current.value;

    axios
      .post(
        `${WEBSERVICE}/apiKey/generateKeys`,
        {
          merchant_id,
          merchant_uuid,
          keyName,
          securityCode,
          emailOtp,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },        }
      )
      .then((response) => {
        if (response.data.error?.error_data !== 0) {
          showToast("error", response.data.error?.error_message);
        } else {
          showToast("success", response.data.error?.error_message);
          this.setState({ newApiKeyGen: response.data.apiKey });
          this.setState({ newApiSecretKeyGen: response.data.secretKey });
          this.setState({
            twoFactorAPIKeyModal: false,
          });
          this.getApiKeyList();
        }
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  componentDidMount() {
    this.setState({
      permission: currentPageAccess(),
    });
    this.handleRenderAssets();
    this.renderUserSettingsData();
    this.renderMerchantSettings();
    this.showHiddenNumber();
    this.renderAllIndustry();
    this.allApiTypeKey();
    this.getApiKeyList();

    if (
      localStorage.getItem(SITENAMEALIAS + "_need_tolerance_setting") == "true"
    ) {
      this.handleSettingsToggle("app");
      this.setState(
        {
          showAutomaticExceptionHandlingModal: true,
          selectedCurrencyIdForAutomaticExceptionHandling: localStorage.getItem(
            SITENAMEALIAS + "_need_tolerance_setting_for_currency"
          ),
        },
        () => {
          this.renderSettingsForAutomaticExceptionHandling(
            this.state.selectedCurrencyIdForAutomaticExceptionHandling
          );
          setTimeout(() => {
            localStorage.removeItem(SITENAMEALIAS + "_need_tolerance_setting");
            localStorage.removeItem(
              SITENAMEALIAS + "_need_tolerance_setting_for_currency"
            );
          }, 2000);
        }
      );
    }

    if (localStorage.getItem("secondStatusCheckForNewOtpTimer") == "true") {
      this.startTimeForNewPhno(localStorage.getItem("cdotpfornewphno"));
      this.setState({
        secondStatusCheckForNewOtpTimer: true,
        sendOtpInNewnoBtn: true,
        isTimerShow2: true,
        timertxt2: localStorage.getItem("cdotpfornewphno"),
      });
    } else {
      this.setState({
        secondStatusCheckForNewOtpTimer: false,
      });
    }
    if (localStorage.getItem("secondStatusCheckForOtpTimer") == "true") {
      this.startTimeForChangePhno(localStorage.getItem("cdotpforchangephno"));
      this.setState({
        secondStatusCheckForOtpTimer: true,
        sendOtpInRegnoBtn: true,
        isTimerShow: true,
        timertxt: localStorage.getItem("cdotpforchangephno"),
      });
    } else {
      this.setState({
        secondStatusCheckForOtpTimer: false,
      });
    }

    if (localStorage.getItem("secstatuscheckForEmailOtpTimer") == "true") {
      this.startTimerForEmailOtp(localStorage.getItem("cdotpforemail2fa"));
      this.setState({
        secstatuscheckForEmailOtpTimer: true,
        sendEmailOtpFor2faBtn: true,
        sendEmailOtpBtn: true,
        showEmailOtpTimer: true,
        proceedEmailOtpBtn: false,
        emailOtpTimerTxt: localStorage.getItem("cdotpforemail2fa"),
      });
    } else {
      this.setState({
        secstatuscheckForEmailOtpTimer: false,
        sendEmailOtpBtn: false,
        proceedEmailOtpBtn: true,
      });
    }
  }

  handleAPICreate = () => {
    if (this.state.newAPIKeyName == "" || this.state.newAPIKeyName == null) {
      showToast("error", "Please add a API key name");
    } else {
      if (
        localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
      ) {
        this.setState({
          twoFactorAPIKeyModalStatus: "Create",
        });
        this.setState({
          twoFactorAPIKeyModal: true,
        });
        this.sendEmailFor2fa();
      } else {
        showToast("error", "Please turn on Google Authentication in Settings.");
      }
    }
  };

  handleAPIEdit = () => {
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "Edit",
      });
      this.setState({
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteApiKey = (data) => {
    this.state.deletePayload = {
      id: data.id,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      keyName: data.keyName,
      action: "DELETE",
      ipAddress: data.ipAddress,
      isRead: data.isRead,
      isDashboard: data.isDashboard,
      isPayments: data.isPayments,
      isPaymentButton: data.isPaymentButton,
      isRecurringPayment: data.isRecurringPayment,
      isEmailBilling: data.isEmailBilling,
      isHostedCatalog: data.isHostedCatalog,
      isInsights: data.isInsights,
    };

    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "Delete",
      });
      this.setState({
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  handleDeleteAll = () => {
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") === "1"
    ) {
      this.setState({
        twoFactorAPIKeyModalStatus: "DeleteAll",
      });
      this.setState({
        twoFactorAPIKeyModal: true,
      });
      this.sendEmailFor2fa();
    } else {
      showToast("error", "Please turn on Google Authentication in Settings.");
    }
  };

  updateApiKey = async () => {
    const selected = this.state.selectedApiKey;

    const favorite = [];
    if (selected.isRead) favorite.push("1");
    if (selected.isDashboard) favorite.push("4");
    if (selected.isPayments) favorite.push("5");
    if (selected.isPaymentButton) favorite.push("6");
    if (selected.isRecurringPayment) favorite.push("7");
    if (selected.isEmailBilling) favorite.push("8");
    if (selected.isHostedCatalog) favorite.push("9");
    if (selected.isInsights) favorite.push("10");

    const authObj = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      merchant_uuid: getAuthUuid(),
      id: selected.id,
      keyName: selected.keyName,
      apiKey: selected.apiKey,
      secretKey: selected.secretKey,
      securityCode: this.gaCodeFor2faOff.current.value,
      emailOtp: this.emailOtpForTwoFaOff.current.value,
      action: "UPDATE",
      isRead: favorite.includes("1") ? 1 : 0,
      isDashboard: favorite.includes("4") ? 1 : 0,
      isPayments: favorite.includes("5") ? 1 : 0,
      isPaymentButton: favorite.includes("6") ? 1 : 0,
      isRecurringPayment: favorite.includes("7") ? 1 : 0,
      isEmailBilling: favorite.includes("8") ? 1 : 0,
      isHostedCatalog: favorite.includes("9") ? 1 : 0,
      isInsights: favorite.includes("10") ? 1 : 0,
      ipAddress: this.state.ipListTemp.join(","),
    };

    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },        body: JSON.stringify(authObj),
      });

      const result = await response.json();

      console.log("result", result);
      this.setState({ showEditApiModal: false });
      this.setState({
        twoFactorAPIKeyModal: false,
      });

      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);
        this.getApiKeyList();
      }
    } catch (error) {
      console.error("API update failed:", error);
    }
  };

  deleteApiKeyById = async (e) => {
    this.state.deletePayload.securityCode = this.gaCodeFor2faOff.current.value;
    this.state.deletePayload.emailOtp = this.emailOtpForTwoFaOff.current.value;

    try {
      const response = await fetch(WEBSERVICE + "/apiKey/updateKeys", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },        body: JSON.stringify(this.state.deletePayload),
      });

      const result = await response.json();

      if (result.error?.error_data !== 0) {
        showToast("error", result.error?.error_message);
      } else {
        showToast("success", result.error?.error_message);
        this.setState({ showEditApiModal: false });
        this.setState({
          twoFactorAPIKeyModal: false,
        });
        this.getApiKeyList();
      }
    } catch (error) {
      console.error("API update failed:", error);
    }
  };

  deleteApiKey = async (e) => {
    const merchant_id = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const merchant_uuid = getAuthUuid();

    axios
      .post(
        `${WEBSERVICE}/apiKey/deleteAllApiKeys`,
        {
          merchant_id,
          merchant_uuid,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "bearer " + getAuthToken(),
            UUID: getAuthUuid(),
          },        }
      )
      .then((res) => {
        let response = res.data.error;
        this.setState({ showEditApiModal: false });

        if (response.error_data != 0) {
          showToast("error", response.error_message);
        } else {
          showToast("success", "API keys deleted successfuly");
        }
      })
      .catch((error) => {
        console.error("Error fetching API keys:", error);
      });
  };

  handleDeleteAllAPIs = () => {
    showConfirm(
      "Delete All APIs",
      "Are you sure you want to delete all APIs?",
      "warning",
      () => {
        this.handleDeleteAll();
      }
    );
  };

  handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    showToast("success", "Copied");
  };

  render() {
    const { apiKey, apiSecret, permissions } = this.state;

    const s = {
      pageWrapper: {
        padding: "40px 24px 60px",
      },
      pageHeader: {
        marginBottom: "28px",
      },
      pageTitle: {
        fontSize: "24px",
        fontWeight: "700",
        color: "var(--text-color)",
        margin: 0,
      },
      pageSubtitle: {
        fontSize: "13px",
        opacity: 0.5,
        margin: "4px 0 0",
      },
      card: {
        background: "var(--body-color-less)",
        borderRadius: "16px",
        border: "1px solid var(--body-color-less2)",
        padding: "28px 28px 24px",
        marginBottom: "24px",
        boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
      },
      cardHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "20px",
        paddingBottom: "14px",
        borderBottom: "2px solid var(--body-color-less2)",
      },
      cardHeaderLeft: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
      },
      iconBox: (color) => ({
        width: "40px",
        height: "40px",
        borderRadius: "10px",
        background:
          color === "blue"
            ? "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 85%), color-mix(in srgb, var(--btn-color), transparent 92%))"
            : color === "green"
            ? "linear-gradient(135deg, rgba(16,185,129,0.15), rgba(16,185,129,0.06))"
            : color === "amber"
            ? "linear-gradient(135deg, rgba(245,158,11,0.15), rgba(245,158,11,0.06))"
            : color === "teal"
            ? "linear-gradient(135deg, rgba(20,184,166,0.15), rgba(20,184,166,0.06))"
            : "linear-gradient(135deg, rgba(139,92,246,0.15), rgba(139,92,246,0.06))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        color:
          color === "blue"
            ? "var(--btn-color)"
            : color === "green"
            ? "#10b981"
            : color === "amber"
            ? "#f59e0b"
            : color === "teal"
            ? "#14b8a6"
            : "#8b5cf6",
        flexShrink: 0,
      }),
      sectionTitle: {
        fontSize: "17px",
        fontWeight: "700",
        margin: 0,
        color: "var(--text-color)",
      },
      sectionDesc: {
        fontSize: "12px",
        opacity: 0.6,
        margin: 0,
      },
      btnEdit: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 20px",
        background: "transparent",
        color: "var(--btn-color)",
        border: "2px solid var(--btn-color)",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.2s ease",
        textDecoration: "none",
      },
      btnDisabled: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "8px 20px",
        background: "var(--body-color-less2)",
        color: "var(--text-color)",
        border: "none",
        borderRadius: "8px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: "not-allowed",
        opacity: 0.5,
      },
      infoRow: {
        display: "flex",
        alignItems: "flex-start",
        padding: "12px 16px",
        borderRadius: "10px",
        background: "var(--body-color)",
        border: "1px solid var(--body-color-less2)",
        marginBottom: "8px",
      },
      infoLabel: {
        width: "200px",
        flexShrink: 0,
        fontSize: "13px",
        fontWeight: "600",
        color: "var(--text-color)",
        opacity: 0.7,
      },
      infoValue: {
        fontSize: "14px",
        fontWeight: "500",
        color: "var(--text-color)",
        flex: 1,
      },
      chargeItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 16px",
        borderRadius: "8px",
        background: "var(--body-color)",
        border: "1px solid var(--body-color-less2)",
        marginBottom: "6px",
      },
    };

    return (
      <Fragment>
        <style>{`
          @media (max-width: 576px) {
            .bs-page-wrapper { padding: 20px 14px 40px !important; }
            .bs-card { padding: 18px 16px 16px !important; }
            .bs-card-header { flex-direction: column !important; align-items: flex-start !important; gap: 12px !important; }
            .bs-card-header-left { gap: 10px !important; }
            .bs-card-header-left .bs-icon-box { width: 34px !important; height: 34px !important; font-size: 15px !important; }
            .bs-section-title { font-size: 15px !important; }
            .bs-section-desc { font-size: 11px !important; }
            .bs-info-row { flex-direction: column !important; gap: 4px !important; padding: 10px 14px !important; }
            .bs-info-label { width: 100% !important; font-size: 12px !important; }
            .bs-info-value { font-size: 13px !important; word-break: break-all; }
            .bs-charge-item { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; padding: 10px 14px !important; }
            .bs-fee-option { padding: 14px 14px !important; gap: 10px !important; }
            .bs-fee-title { font-size: 13px !important; }
            .bs-fee-desc { font-size: 11px !important; }
            .bs-btn-edit { padding: 6px 14px !important; font-size: 12px !important; }
          }
        `}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            {this.state.showAppSettings && (
              <div className="bs-page-wrapper" style={s.pageWrapper}>
                <PageHeader
                  icon="mdi-office-building"
                  title="Business Settings"
                  subtitle="Manage your merchant profile, volume limits, and order preferences"
                />

                {/* MERCHANT PROFILE CARD */}
                <div className="bs-card" style={s.card}>
                  <div className="bs-card-header" style={s.cardHeader}>
                    <div
                      className="bs-card-header-left"
                      style={s.cardHeaderLeft}
                    >
                      <div className="bs-icon-box" style={s.iconBox("blue")}>
                        <i className="fas fa-store"></i>
                      </div>
                      <div>
                        <h3 className="bs-section-title" style={s.sectionTitle}>
                          Merchant Profile
                        </h3>
                        <p className="bs-section-desc" style={s.sectionDesc}>
                          Your business identity and contact details
                        </p>
                      </div>
                    </div>
                    {this.state.permission == "WRITE" ? (
                      <button
                        className="bs-btn-edit"
                        style={s.btnEdit}
                        onClick={() => {
                          this.setState(
                            { showMerchantSettingsModal: true },
                            () => {
                              this.renderMerchantProfileData();
                            }
                          );
                        }}
                      >
                        <i className="fas fa-pen"></i> Edit
                      </button>
                    ) : (
                      <button
                        className="bs-btn-edit"
                        style={s.btnDisabled}
                        onClick={() => {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                        }}
                        disabled
                      >
                        Edit
                      </button>
                    )}
                  </div>
                  <div className="bs-info-row" style={s.infoRow}>
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i
                        className="fas fa-tag"
                        style={{ marginRight: "6px", opacity: 0.5 }}
                      ></i>
                      Name
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>
                      {this.state.merchantName}
                    </span>
                  </div>
                  <div className="bs-info-row" style={s.infoRow}>
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i
                        className="fas fa-industry"
                        style={{ marginRight: "6px", opacity: 0.5 }}
                      ></i>
                      Industry
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>
                      {this.state.merchantIndustry}
                    </span>
                  </div>
                  <div className="bs-info-row" style={s.infoRow}>
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i
                        className="fas fa-globe"
                        style={{ marginRight: "6px", opacity: 0.5 }}
                      ></i>
                      Website
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>
                      {this.state.merchantWebsite}
                    </span>
                  </div>
                  <div className="bs-info-row" style={s.infoRow}>
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i
                        className="fas fa-phone"
                        style={{ marginRight: "6px", opacity: 0.5 }}
                      ></i>
                      Support Phone
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>
                      {this.state.supportPhone}
                    </span>
                  </div>
                  <div
                    className="bs-info-row"
                    style={{ ...s.infoRow, marginBottom: 0 }}
                  >
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i
                        className="fas fa-envelope"
                        style={{ marginRight: "6px", opacity: 0.5 }}
                      ></i>
                      Support Email
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>
                      {this.state.supportEmail}
                    </span>
                  </div>
                </div>

                {/* TRANSACTION CHARGES CARD */}
                <div className="bs-card" style={s.card}>
                  <div className="bs-card-header" style={s.cardHeader}>
                    <div
                      className="bs-card-header-left"
                      style={s.cardHeaderLeft}
                    >
                      <div className="bs-icon-box" style={s.iconBox("amber")}>
                        <i className="fas fa-receipt"></i>
                      </div>
                      <div>
                        <h3 className="bs-section-title" style={s.sectionTitle}>
                          Transaction Charges
                        </h3>
                        <p className="bs-section-desc" style={s.sectionDesc}>
                          Fee structure for each supported asset
                        </p>
                      </div>
                    </div>
                  </div>
                  {this.state.currentPlanTxnCharges.length > 0 ? (
                    this.state.currentPlanTxnCharges.map((i) => (
                      <div
                        key={i.asset}
                        className="bs-charge-item"
                        style={s.chargeItem}
                      >
                        <span style={{ fontSize: "14px", fontWeight: "600" }}>
                          <i
                            className="fas fa-coins"
                            style={{
                              marginRight: "8px",
                              opacity: 0.4,
                              fontSize: "12px",
                            }}
                          ></i>
                          {i.asset}
                        </span>
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            padding: "4px 14px",
                            borderRadius: "20px",
                            background: "rgba(245,158,11,0.1)",
                            color: "#f59e0b",
                          }}
                        >
                          {i.charge}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "24px",
                        opacity: 0.5,
                        fontSize: "14px",
                      }}
                    >
                      <i
                        className="fas fa-receipt"
                        style={{
                          fontSize: "24px",
                          display: "block",
                          marginBottom: "8px",
                          opacity: 0.3,
                        }}
                      ></i>
                      No transaction charges configured
                    </div>
                  )}
                </div>

                {/* PROCESSING FEE HANDLING CARD */}
                <div className="bs-card" style={s.card}>
                  <div className="bs-card-header" style={s.cardHeader}>
                    <div
                      className="bs-card-header-left"
                      style={s.cardHeaderLeft}
                    >
                      <div className="bs-icon-box" style={s.iconBox("teal")}>
                        <i className="fas fa-hand-holding-usd"></i>
                      </div>
                      <div>
                        <h3 className="bs-section-title" style={s.sectionTitle}>
                          Processing Fee Handling
                        </h3>
                        <p className="bs-section-desc" style={s.sectionDesc}>
                          Choose how processing fees are applied to your
                          payments
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {/* Option 1 — Customer pays */}
                    <label
                      className="bs-fee-option"
                      onClick={() => {
                        if (this.state.permission !== "WRITE") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.setState({ processingFeeHandling: "customer" });
                      }}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "14px",
                        padding: "16px 20px",
                        borderRadius: "12px",
                        border:
                          this.state.processingFeeHandling === "customer"
                            ? "2px solid var(--btn-color)"
                            : "2px solid var(--body-color-less2)",
                        background:
                          this.state.processingFeeHandling === "customer"
                            ? "color-mix(in srgb, var(--btn-color), transparent 94%)"
                            : "var(--body-color)",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            border:
                              this.state.processingFeeHandling === "customer"
                                ? "5px solid var(--btn-color)"
                                : "2px solid var(--body-color-less2)",
                            background: "var(--body-color)",
                            transition: "all 0.2s ease",
                          }}
                        />
                      </div>
                      <div>
                        <div
                          className="bs-fee-title"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "4px",
                          }}
                        >
                          The customer pays the processing fee
                        </div>
                        <div
                          className="bs-fee-desc"
                          style={{
                            fontSize: "12px",
                            opacity: 0.55,
                            color: "var(--text-color)",
                          }}
                        >
                          The fee will be added to the checkout total.
                        </div>
                      </div>
                    </label>

                    {/* Option 2 — Merchant absorbs */}
                    <label
                      className="bs-fee-option"
                      onClick={() => {
                        if (this.state.permission !== "WRITE") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.setState({ processingFeeHandling: "merchant" });
                      }}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "14px",
                        padding: "16px 20px",
                        borderRadius: "12px",
                        border:
                          this.state.processingFeeHandling === "merchant"
                            ? "2px solid var(--btn-color)"
                            : "2px solid var(--body-color-less2)",
                        background:
                          this.state.processingFeeHandling === "merchant"
                            ? "color-mix(in srgb, var(--btn-color), transparent 94%)"
                            : "var(--body-color)",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                      }}
                    >
                      <div style={{ paddingTop: "2px", flexShrink: 0 }}>
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            border:
                              this.state.processingFeeHandling === "merchant"
                                ? "5px solid var(--btn-color)"
                                : "2px solid var(--body-color-less2)",
                            background: "var(--body-color)",
                            transition: "all 0.2s ease",
                          }}
                        />
                      </div>
                      <div>
                        <div
                          className="bs-fee-title"
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "var(--text-color)",
                            marginBottom: "4px",
                          }}
                        >
                          Merchant absorbs the processing fee
                        </div>
                        <div
                          className="bs-fee-desc"
                          style={{
                            fontSize: "12px",
                            opacity: 0.55,
                            color: "var(--text-color)",
                          }}
                        >
                          The fee will be deducted from your payout.
                        </div>
                      </div>
                    </label>
                  </div>

                  {/* Save button */}
                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      disabled={this.state.permission !== "WRITE"}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "9px 24px",
                        background: "var(--btn-color)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor:
                          this.state.permission !== "WRITE"
                            ? "not-allowed"
                            : "pointer",
                        opacity: this.state.permission !== "WRITE" ? 0.5 : 1,
                        transition: "opacity 0.2s ease",
                      }}
                      onClick={() => {
                        if (this.state.permission !== "WRITE") {
                          showToast(
                            "error",
                            "You need write access to perform this operation"
                          );
                          return;
                        }
                        this.handleUpdateProcessingFeeStatus();
                      }}
                    >
                      <i className="fas fa-check"></i> Save Preference
                    </button>
                  </div>
                </div>

                {/* ORDER SETTINGS CARD */}
                {/* <div className="bs-card" style={s.card}>
                  <div className="bs-card-header" style={s.cardHeader}>
                    <div className="bs-card-header-left" style={s.cardHeaderLeft}>
                      <div className="bs-icon-box" style={s.iconBox("purple")}>
                        <i className="fas fa-bell"></i>
                      </div>
                      <div>
                        <h3 className="bs-section-title" style={s.sectionTitle}>Order Settings</h3>
                        <p className="bs-section-desc" style={s.sectionDesc}>Configure notification preferences</p>
                      </div>
                    </div>
                    {this.state.permission == "WRITE" ? (
                      <button
                        className="bs-btn-edit"
                        style={s.btnEdit}
                        onClick={() => {
                          this.setState({ showOrderSettingsModal: true });
                        }}
                      >
                        <i className="fas fa-pen"></i> Edit
                      </button>
                    ) : (
                      <button
                        className="bs-btn-edit"
                        style={s.btnDisabled}
                        onClick={() => {
                          showToast("error", "You need write access to perform this operation");
                        }}
                        disabled
                      >
                        Edit
                      </button>
                    )}
                  </div>
                  <div className="bs-info-row" style={s.infoRow}>
                    <span className="bs-info-label" style={s.infoLabel}>
                      <i className="fas fa-paper-plane" style={{ marginRight: "6px", opacity: 0.5 }}></i>
                      Send Notification to
                    </span>
                    <span className="bs-info-value" style={s.infoValue}>{this.state.sendNotificationTo}</span>
                  </div>
                </div> */}
              </div>
            )}

            <Footer />
          </div>

          {/* ======= ALL MODALS (unchanged) ======= */}

          <Modal
            show={this.state.showEditApiModal}
            backdrop="static"
            keyboard={false}
            size="md"
            onHide={() => this.setState({ showEditApiModal: false })}
          >
            <Modal.Header>
              <Modal.Title>Edit API</Modal.Title>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => this.setState({ showEditApiModal: false })}
                style={{ marginLeft: "auto" }}
              >
                X
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3 mr-3">
                <div className="form-group">
                  <label>API Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.selectedApiKey?.keyName || ""}
                    onChange={(e) =>
                      this.setState({
                        selectedApiKey: {
                          ...this.state.selectedApiKey,
                          keyName: e.target.value,
                        },
                      })
                    }
                    maxLength={30}
                  />
                </div>
                <div className="form-group">
                  <label>Public Key</label>
                  <div>{this.state.selectedApiKey?.apiKey}</div>
                </div>
                <div className="form-group">
                  <label>Secret Key</label>
                  <div>*******************</div>
                </div>
                <div className="form-group">
                  <label>API Permissions</label>
                  <div
                    className="d-flex flex-wrap"
                    style={{ marginLeft: "5px" }}
                  >
                    {this.state.apitype?.map((type) => {
                      const fieldMapping = {
                        READ: "isRead",
                        DEPOSIT: "isDeposit",
                        WITHDRAW: "isWithdraw",
                        DASHBOARD: "isDashboard",
                        PAYMENTS: "isPayments",
                        "PAYMENT BUTTON": "isPaymentButton",
                        "RECURRING PAYMENT": "isRecurringPayment",
                        "EMAIL BILLING": "isEmailBilling",
                        "HOSTED CATALOG": "isHostedCatalog",
                        INSIGHTS: "isInsights",
                      };
                      const fieldKey =
                        fieldMapping[type.apiTypeName?.toUpperCase()];
                      const isChecked =
                        fieldKey && this.state.selectedApiKey?.[fieldKey] === 1;
                      return (
                        <div
                          key={type.apiTypeId}
                          className="form-check mr-3 mb-2"
                          style={{ minWidth: "180px" }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={isChecked}
                            onChange={(e) => {
                              const updatedKey = fieldKey;
                              const updatedValue = e.target.checked ? 1 : 0;
                              this.setState((prevState) => ({
                                selectedApiKey: {
                                  ...prevState.selectedApiKey,
                                  [updatedKey]: updatedValue,
                                },
                              }));
                            }}
                          />
                          <label className="form-check-label small text-nowrap">
                            {type.apiTypeName}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="form-group">
                  <label>IP Access Restrictions</label>
                  <div className="form-check" style={{ marginLeft: "5px" }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={this.state.ipRestrictStatus === 0}
                      onChange={() => this.setState({ ipRestrictStatus: 0 })}
                    />
                    <label className="form-check-label">
                      Unrestricted (Less Secure)
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "5px" }}>
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={this.state.ipRestrictStatus === 1}
                      onChange={() => this.setState({ ipRestrictStatus: 1 })}
                    />
                    <label className="form-check-label">
                      Restrict access to trusted IPs only (Recommended)
                    </label>
                  </div>
                </div>
                {this.state.ipRestrictStatus === 1 && (
                  <>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter IP and press Enter"
                        onKeyUp={(e) => {
                          if (e.key === "Enter") {
                            const ip = e.target.value.trim();
                            if (ip && !this.state.ipListTemp.includes(ip)) {
                              this.setState((prevState) => ({
                                ipListTemp: [...prevState.ipListTemp, ip],
                              }));
                              e.target.value = "";
                            }
                          }
                        }}
                      />
                      <small className="text-primary">
                        Press "Enter" to add new IP address
                      </small>
                    </div>
                    <div className="form-group">
                      <ul className="list-inline">
                        {this.state.ipListTemp.map((ip) => (
                          <li
                            key={ip}
                            className="badge badge-secondary mr-2"
                            style={{ padding: "8px 10px" }}
                          >
                            {ip}{" "}
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                this.setState((prev) => ({
                                  ipListTemp: prev.ipListTemp.filter(
                                    (i) => i !== ip
                                  ),
                                }))
                              }
                            >
                              &times;
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  this.handleAPIEdit();
                }}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => this.setState({ showEditApiModal: false })}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={this.state.showOrderSettingsModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Edit Order Settings</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ marginLeft: "1rem" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name="notificationEmail"
                    checked={this.state.sendNotificationToRegisteredAddress}
                    onChange={() => {
                      this.setState({
                        sendNotificationToRegisteredAddress: true,
                        sendNotificationToDifferentAddress: false,
                      });
                    }}
                    style={{ margin: 0 }}
                  />
                  <span>
                    Send notification to {this.state.sendNotificationTo}
                  </span>
                </label>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                >
                  <input
                    type="radio"
                    name="notificationEmail"
                    checked={this.state.sendNotificationToDifferentAddress}
                    onChange={() => {
                      this.setState({
                        sendNotificationToDifferentAddress: true,
                        sendNotificationToRegisteredAddress: false,
                      });
                    }}
                    style={{ margin: 0 }}
                  />
                  <span>Send notification to different email address</span>
                </label>
                {this.state.sendNotificationToDifferentAddress && (
                  <div style={{ marginTop: "10px" }}>
                    <label style={{ display: "block", marginBottom: "5px" }}>
                      Enter Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      defaultValue={this.state.newNotificationEmail}
                      onBlur={(e) => {
                        this.handleCheckEmail(e);
                      }}
                      placeholder="Enter new email address"
                    />
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleUpdateOrderSetting}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  onClick={() => {
                    this.setState({ showOrderSettingsModal: false });
                  }}
                >
                  Cancel
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showIncreaseVolumeModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Approved Volume</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-4">
                <div className="mb-4">
                  <label className="text-primary mb-2">Light Plan </label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total ${
                      this.getPlanDetails("Light Plan").daily_amount_cap
                    }{" "}
                    a day and{" "}
                    {this.getPlanDetails("Light Plan").monthly_transaction_cap <
                    0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Light Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  {this.state.isLightPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "1",
                          showTaxModal: true,
                        });
                      }}
                      className="btn btn-primary"
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Basic Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total ${
                      this.getPlanDetails("Basic Plan").daily_amount_cap
                    }{" "}
                    a day and{" "}
                    {this.getPlanDetails("Basic Plan").monthly_transaction_cap <
                    0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Basic Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                    Merchant needs Valid Govt issued Tax ID and a functioning
                    online website.
                  </p>
                  {this.state.isBasicPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "2",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Business Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Total $
                    {this.getPlanDetails("Business Plan").daily_amount_cap} a
                    day and{" "}
                    {this.getPlanDetails("Business Plan")
                      .monthly_transaction_cap < 0
                      ? "unlimited"
                      : "only " +
                        this.getPlanDetails("Business Plan")
                          .monthly_transaction_cap}{" "}
                    in a month.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-2-box text-primary mr-2"></i>
                    Merchant needs to submit.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-3-box text-primary mr-2"></i>
                    Valid Govt. issued Tax Id.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-4-box text-primary mr-2"></i>
                    Principal/Director/Owner's Photo Identification.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-5-box text-primary mr-2"></i>
                    Proof of Business Address.
                  </p>
                  <p>
                    <i className="mdi mdi-numeric-6-box text-primary mr-2"></i>
                    Incorporation documents/ Business Registration.
                  </p>
                  {this.state.isBusinessPlanApplied ? (
                    <span className="text-success">Activated</span>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          selectedPlanIdForApply: "3",
                          showTaxModal: true,
                          showIncreaseVolumeModal: false,
                        });
                      }}
                    >
                      {" "}
                      Apply
                    </button>
                  )}
                </div>
                <hr />
                <div className="mb-4">
                  <label className="text-primary mb-2">Enterprise Plan</label>
                  <p>
                    <i className="mdi mdi-numeric-1-box text-primary mr-2"></i>
                    Contact us more info{" "}
                    <a herf="javascript:void(0)">
                      contact@
                      {localStorage.getItem(SITENAMEALIAS + "_exchange")}.com
                    </a>
                  </p>
                </div>
                <hr />
              </div>
              <button
                type="button"
                className="btn btn-secondary ml-4"
                onClick={() => {
                  this.setState({ showIncreaseVolumeModal: false });
                }}
              >
                Cancel
              </button>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.googleAuthModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Google Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3">
                <div className="form-group">
                  <div
                    style={{
                      height: "auto",
                      margin: "10px auto",
                      maxWidth: 250,
                      width: "100%",
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={this.state.qrcodeValue}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <input
                    type="password"
                    value={this.state.qrcode}
                    className="form-control mb-3"
                    ref={this.qrCodeValueRef}
                    placeholder="Google Authentication Code"
                    onChange={(e) => {
                      var regex = /^[0-9\b]+$/;
                      if (e.target.value === "" || regex.test(e.target.value)) {
                        this.setState({
                          qrcode: e.target.value,
                          isInputQrCodeAvailable: false,
                        });
                      }
                    }}
                  />
                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isInputQrCodeAvailable}
                        onClick={this.googleAuthOtpVerification}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btn-secondary ml-2"
                        onClick={() => {
                          this.setState({
                            googleAuthModal: false,
                            isGoogleAuthChecked: false,
                          });
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showMerchantSettingsModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title className="text-center">
                Edit Merchant Settings
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-3">
                <div className="form-group">
                  <label>Organization Name*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mOrganizationName}
                    onChange={(e) => {
                      this.setState({ mOrganizationName: e.target.value });
                    }}
                    onBlur={this.handleOrgName}
                    placeholder="Enter Organization Name"
                  />
                  {this.state.orgNameError && (
                    <small className="text-danger">
                      Please insert valid organization name
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Description*</label>
                  <textarea
                    className="form-control"
                    value={this.state.mDesc}
                    onChange={(e) => {
                      this.setState({ mDesc: e.target.value });
                    }}
                    onBlur={this.handleDiscription}
                    row="2"
                    placeholder="Enter Description"
                  ></textarea>
                  {this.state.descriptionError && (
                    <small className="text-danger">
                      Please insert valid description
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Industry*</label>
                  <select
                    className="form-control"
                    value={this.state.selectedIndustryForMerchantEdit}
                    onChange={(e) => {
                      this.setState({
                        selectedIndustryForMerchantEdit: e.target.value,
                      });
                    }}
                  >
                    <option value="">Select Industry</option>
                    {this.state.industryList.map((i) => (
                      <option key={i.industry_id} value={i.industry_id}>
                        {i.industry_name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label>Website*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mWebsite}
                    onChange={(e) => {
                      this.setState({ mWebsite: e.target.value });
                    }}
                    onBlur={this.handleWebsite}
                    placeholder="Enter Website"
                  />
                  {this.state.websiteError && (
                    <small className="text-danger">
                      Please insert valid website name
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Support Phone*</label>
                  <PhoneInput
                    country={"us"}
                    value={this.state.mSupportPhone}
                    onChange={(phone) => {
                      this.setState({ mSupportPhone: phone });
                      const digitsOnly = phone.replace(/\D/g, "");
                      if (digitsOnly.length >= 6 && digitsOnly.length <= 15) {
                        this.setState({
                          phoneError: false,
                          btnUpdateSetting: false,
                        });
                      } else {
                        this.setState({
                          phoneError: true,
                          btnUpdateSetting: true,
                        });
                      }
                    }}
                    inputStyle={{ width: "100%" }}
                    placeholder="Enter Phone No"
                  />
                  {this.state.phoneError && (
                    <small className="text-danger">
                      Phone number must be between 6 and 15 digits
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <label>Preferred Contact Method</label>
                  <div>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="preferredContact"
                        checked={this.state.isPreferedEmailChecked}
                        onChange={() => {
                          this.setState({
                            isPreferedEmailChecked: true,
                            isPreferedWebsiteChecked: false,
                          });
                        }}
                        style={{ margin: 0 }}
                      />
                      <span>Email</span>
                    </label>
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="preferredContact"
                        checked={this.state.isPreferedWebsiteChecked}
                        onChange={() => {
                          this.setState({
                            isPreferedWebsiteChecked: true,
                            isPreferedEmailChecked: false,
                          });
                        }}
                        style={{ margin: 0 }}
                      />
                      <span>Website</span>
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <label>Support Email*</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.mSupportEmail}
                    onChange={(e) => {
                      this.setState({ mSupportEmail: e.target.value });
                    }}
                    onBlur={this.handleEmailId}
                    placeholder="Enter Email"
                  />
                  {this.state.emailIdError && (
                    <small className="text-danger">
                      Please insert valid email
                    </small>
                  )}
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      checked={this.state.isAcceptBtcAtRetailChecked}
                      onClick={(e) => {
                        this.setState({
                          isAcceptBtcAtRetailChecked:
                            !this.state.isAcceptBtcAtRetailChecked,
                        });
                      }}
                    />{" "}
                    <span>Do you accept bitcoin at a retail location?</span>
                  </div>
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      checked={this.state.isDisplayAddressChecked}
                      onClick={(e) => {
                        this.setState({
                          isDisplayAddressChecked:
                            !this.state.isDisplayAddressChecked,
                        });
                      }}
                    />{" "}
                    <span>
                      Do you want to display your address on your bills?
                    </span>
                  </div>
                </div>
                <div className="form-group">
                  <div className=" d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      checked={this.state.isDifferenAddressChecked}
                      onClick={(e) => {
                        console.log(e.target.value);
                        this.setState({
                          isDifferenAddressChecked:
                            !this.state.isDifferenAddressChecked,
                        });
                      }}
                    />{" "}
                    <span>
                      Do you want to specify an address different from your
                      organisation address?
                    </span>
                  </div>
                </div>
                {this.state.isDifferenAddressChecked && (
                  <div>
                    <div className="form-group">
                      <div>
                        <label>Address Line 1*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 1"
                          value={this.state.mAddress1}
                          onChange={(e) => {
                            this.setState({ mAddress1: e.target.value });
                          }}
                          onBlur={this.handleAddress1}
                        />
                        {this.state.address1_error && (
                          <small className="text-danger">
                            Please insert valid address
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Address Line 2</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Address Line 2"
                          value={this.state.mAddress2}
                          onChange={(e) => {
                            this.setState({ mAddress2: e.target.value });
                          }}
                          onBlur={this.handleAddress2}
                        />
                        {this.state.address2_error && (
                          <small className="text-danger">
                            Please insert valid address
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>City*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter City"
                          value={this.state.mCity}
                          onChange={(e) => {
                            this.setState({ mCity: e.target.value });
                          }}
                          onBlur={this.handleCity}
                        />
                        {this.state.cityError && (
                          <small className="text-danger">
                            Please insert valid city name
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>State*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter State"
                          value={this.state.mState}
                          onChange={(e) => {
                            this.setState({ mState: e.target.value });
                          }}
                          onBlur={this.handleState}
                        />
                        {this.state.stateError && (
                          <small className="text-danger">
                            Please insert valid state
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Zipcode*</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Zip"
                          value={this.state.mZip}
                          onChange={(e) => {
                            if (_isValidZipCode(e.target.value)) {
                              this.setState({ mZip: e.target.value });
                            } else {
                              e.target.value = e.target.value.slice(0, -1);
                            }
                          }}
                          onBlur={this.handleZipcode}
                        />
                        {this.state.zipcodeError && (
                          <small className="text-danger">
                            Please insert valid zipcode
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <div>
                        <label>Country*</label>
                        <select
                          id="country"
                          name="country"
                          className="form-control"
                          value={this.state.mCountry}
                          onChange={(e) => {
                            this.setState({ mCountry: e.target.value });
                          }}
                        >
                          <option value="Afghanistan">Afghanistan</option>
                          <option value="Åland Islands">Åland Islands</option>
                          <option value="Albania">Albania</option>
                          <option value="Algeria">Algeria</option>
                          <option value="American Samoa">American Samoa</option>
                          <option value="Andorra">Andorra</option>
                          <option value="Angola">Angola</option>
                          <option value="Anguilla">Anguilla</option>
                          <option value="Antarctica">Antarctica</option>
                          <option value="Antigua and Barbuda">
                            Antigua and Barbuda
                          </option>
                          <option value="Argentina">Argentina</option>
                          <option value="Armenia">Armenia</option>
                          <option value="Aruba">Aruba</option>
                          <option value="Australia">Australia</option>
                          <option value="Austria">Austria</option>
                          <option value="Azerbaijan">Azerbaijan</option>
                          <option value="Bahamas">Bahamas</option>
                          <option value="Bahrain">Bahrain</option>
                          <option value="Bangladesh">Bangladesh</option>
                          <option value="Barbados">Barbados</option>
                          <option value="Belarus">Belarus</option>
                          <option value="Belgium">Belgium</option>
                          <option value="Belize">Belize</option>
                          <option value="Benin">Benin</option>
                          <option value="Bermuda">Bermuda</option>
                          <option value="Bhutan">Bhutan</option>
                          <option value="Bolivia">Bolivia</option>
                          <option value="Bosnia and Herzegovina">
                            Bosnia and Herzegovina
                          </option>
                          <option value="Botswana">Botswana</option>
                          <option value="Bouvet Island">Bouvet Island</option>
                          <option value="Brazil">Brazil</option>
                          <option value="British Indian Ocean Territory">
                            British Indian Ocean Territory
                          </option>
                          <option value="Brunei Darussalam">
                            Brunei Darussalam
                          </option>
                          <option value="Bulgaria">Bulgaria</option>
                          <option value="Burkina Faso">Burkina Faso</option>
                          <option value="Burundi">Burundi</option>
                          <option value="Cambodia">Cambodia</option>
                          <option value="Cameroon">Cameroon</option>
                          <option value="Canada">Canada</option>
                          <option value="Cape Verde">Cape Verde</option>
                          <option value="Cayman Islands">Cayman Islands</option>
                          <option value="Central African Republic">
                            Central African Republic
                          </option>
                          <option value="Chad">Chad</option>
                          <option value="Chile">Chile</option>
                          <option value="China">China</option>
                          <option value="Christmas Island">
                            Christmas Island
                          </option>
                          <option value="Cocos (Keeling) Islands">
                            Cocos (Keeling) Islands
                          </option>
                          <option value="Colombia">Colombia</option>
                          <option value="Comoros">Comoros</option>
                          <option value="Congo">Congo</option>
                          <option value="Congo, The Democratic Republic of The">
                            Congo, The Democratic Republic of The
                          </option>
                          <option value="Cook Islands">Cook Islands</option>
                          <option value="Costa Rica">Costa Rica</option>
                          <option value="Cote D'ivoire">Cote D'ivoire</option>
                          <option value="Croatia">Croatia</option>
                          <option value="Cuba">Cuba</option>
                          <option value="Cyprus">Cyprus</option>
                          <option value="Czech Republic">Czech Republic</option>
                          <option value="Denmark">Denmark</option>
                          <option value="Djibouti">Djibouti</option>
                          <option value="Dominica">Dominica</option>
                          <option value="Dominican Republic">
                            Dominican Republic
                          </option>
                          <option value="Ecuador">Ecuador</option>
                          <option value="Egypt">Egypt</option>
                          <option value="El Salvador">El Salvador</option>
                          <option value="Equatorial Guinea">
                            Equatorial Guinea
                          </option>
                          <option value="Eritrea">Eritrea</option>
                          <option value="Estonia">Estonia</option>
                          <option value="Ethiopia">Ethiopia</option>
                          <option value="Falkland Islands (Malvinas)">
                            Falkland Islands (Malvinas)
                          </option>
                          <option value="Faroe Islands">Faroe Islands</option>
                          <option value="Fiji">Fiji</option>
                          <option value="Finland">Finland</option>
                          <option value="France">France</option>
                          <option value="French Guiana">French Guiana</option>
                          <option value="French Polynesia">
                            French Polynesia
                          </option>
                          <option value="French Southern Territories">
                            French Southern Territories
                          </option>
                          <option value="Gabon">Gabon</option>
                          <option value="Gambia">Gambia</option>
                          <option value="Georgia">Georgia</option>
                          <option value="Germany">Germany</option>
                          <option value="Ghana">Ghana</option>
                          <option value="Gibraltar">Gibraltar</option>
                          <option value="Greece">Greece</option>
                          <option value="Greenland">Greenland</option>
                          <option value="Grenada">Grenada</option>
                          <option value="Guadeloupe">Guadeloupe</option>
                          <option value="Guam">Guam</option>
                          <option value="Guatemala">Guatemala</option>
                          <option value="Guernsey">Guernsey</option>
                          <option value="Guinea">Guinea</option>
                          <option value="Guinea-bissau">Guinea-bissau</option>
                          <option value="Guyana">Guyana</option>
                          <option value="Haiti">Haiti</option>
                          <option value="Heard Island and Mcdonald Islands">
                            Heard Island and Mcdonald Islands
                          </option>
                          <option value="Holy See (Vatican City State)">
                            Holy See (Vatican City State)
                          </option>
                          <option value="Honduras">Honduras</option>
                          <option value="Hong Kong">Hong Kong</option>
                          <option value="Hungary">Hungary</option>
                          <option value="Iceland">Iceland</option>
                          <option value="India">India</option>
                          <option value="Indonesia">Indonesia</option>
                          <option value="Iran, Islamic Republic of">
                            Iran, Islamic Republic of
                          </option>
                          <option value="Iraq">Iraq</option>
                          <option value="Ireland">Ireland</option>
                          <option value="Isle of Man">Isle of Man</option>
                          <option value="Israel">Israel</option>
                          <option value="Italy">Italy</option>
                          <option value="Jamaica">Jamaica</option>
                          <option value="Japan">Japan</option>
                          <option value="Jersey">Jersey</option>
                          <option value="Jordan">Jordan</option>
                          <option value="Kazakhstan">Kazakhstan</option>
                          <option value="Kenya">Kenya</option>
                          <option value="Kiribati">Kiribati</option>
                          <option value="Korea, Democratic People's Republic of">
                            Korea, Democratic People's Republic of
                          </option>
                          <option value="Korea, Republic of">
                            Korea, Republic of
                          </option>
                          <option value="Kuwait">Kuwait</option>
                          <option value="Kyrgyzstan">Kyrgyzstan</option>
                          <option value="Lao People's Democratic Republic">
                            Lao People's Democratic Republic
                          </option>
                          <option value="Latvia">Latvia</option>
                          <option value="Lebanon">Lebanon</option>
                          <option value="Lesotho">Lesotho</option>
                          <option value="Liberia">Liberia</option>
                          <option value="Libyan Arab Jamahiriya">
                            Libyan Arab Jamahiriya
                          </option>
                          <option value="Liechtenstein">Liechtenstein</option>
                          <option value="Lithuania">Lithuania</option>
                          <option value="Luxembourg">Luxembourg</option>
                          <option value="Macao">Macao</option>
                          <option value="Macedonia, The Former Yugoslav Republic of">
                            Macedonia, The Former Yugoslav Republic of
                          </option>
                          <option value="Madagascar">Madagascar</option>
                          <option value="Malawi">Malawi</option>
                          <option value="Malaysia">Malaysia</option>
                          <option value="Maldives">Maldives</option>
                          <option value="Mali">Mali</option>
                          <option value="Malta">Malta</option>
                          <option value="Marshall Islands">
                            Marshall Islands
                          </option>
                          <option value="Martinique">Martinique</option>
                          <option value="Mauritania">Mauritania</option>
                          <option value="Mauritius">Mauritius</option>
                          <option value="Mayotte">Mayotte</option>
                          <option value="Mexico">Mexico</option>
                          <option value="Micronesia, Federated States of">
                            Micronesia, Federated States of
                          </option>
                          <option value="Moldova, Republic of">
                            Moldova, Republic of
                          </option>
                          <option value="Monaco">Monaco</option>
                          <option value="Mongolia">Mongolia</option>
                          <option value="Montenegro">Montenegro</option>
                          <option value="Montserrat">Montserrat</option>
                          <option value="Morocco">Morocco</option>
                          <option value="Mozambique">Mozambique</option>
                          <option value="Myanmar">Myanmar</option>
                          <option value="Namibia">Namibia</option>
                          <option value="Nauru">Nauru</option>
                          <option value="Nepal">Nepal</option>
                          <option value="Netherlands">Netherlands</option>
                          <option value="Netherlands Antilles">
                            Netherlands Antilles
                          </option>
                          <option value="New Caledonia">New Caledonia</option>
                          <option value="New Zealand">New Zealand</option>
                          <option value="Nicaragua">Nicaragua</option>
                          <option value="Niger">Niger</option>
                          <option value="Nigeria">Nigeria</option>
                          <option value="Niue">Niue</option>
                          <option value="Norfolk Island">Norfolk Island</option>
                          <option value="Northern Mariana Islands">
                            Northern Mariana Islands
                          </option>
                          <option value="Norway">Norway</option>
                          <option value="Oman">Oman</option>
                          <option value="Pakistan">Pakistan</option>
                          <option value="Palau">Palau</option>
                          <option value="Palestinian Territory, Occupied">
                            Palestinian Territory, Occupied
                          </option>
                          <option value="Panama">Panama</option>
                          <option value="Papua New Guinea">
                            Papua New Guinea
                          </option>
                          <option value="Paraguay">Paraguay</option>
                          <option value="Peru">Peru</option>
                          <option value="Philippines">Philippines</option>
                          <option value="Pitcairn">Pitcairn</option>
                          <option value="Poland">Poland</option>
                          <option value="Portugal">Portugal</option>
                          <option value="Puerto Rico">Puerto Rico</option>
                          <option value="Qatar">Qatar</option>
                          <option value="Reunion">Reunion</option>
                          <option value="Romania">Romania</option>
                          <option value="Russian Federation">
                            Russian Federation
                          </option>
                          <option value="Rwanda">Rwanda</option>
                          <option value="Saint Helena">Saint Helena</option>
                          <option value="Saint Kitts and Nevis">
                            Saint Kitts and Nevis
                          </option>
                          <option value="Saint Lucia">Saint Lucia</option>
                          <option value="Saint Pierre and Miquelon">
                            Saint Pierre and Miquelon
                          </option>
                          <option value="Saint Vincent and The Grenadines">
                            Saint Vincent and The Grenadines
                          </option>
                          <option value="Samoa">Samoa</option>
                          <option value="San Marino">San Marino</option>
                          <option value="Sao Tome and Principe">
                            Sao Tome and Principe
                          </option>
                          <option value="Saudi Arabia">Saudi Arabia</option>
                          <option value="Senegal">Senegal</option>
                          <option value="Serbia">Serbia</option>
                          <option value="Seychelles">Seychelles</option>
                          <option value="Sierra Leone">Sierra Leone</option>
                          <option value="Singapore">Singapore</option>
                          <option value="Slovakia">Slovakia</option>
                          <option value="Slovenia">Slovenia</option>
                          <option value="Solomon Islands">
                            Solomon Islands
                          </option>
                          <option value="Somalia">Somalia</option>
                          <option value="South Africa">South Africa</option>
                          <option value="South Georgia and The South Sandwich Islands">
                            South Georgia and The South Sandwich Islands
                          </option>
                          <option value="Spain">Spain</option>
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Sudan">Sudan</option>
                          <option value="Suriname">Suriname</option>
                          <option value="Svalbard and Jan Mayen">
                            Svalbard and Jan Mayen
                          </option>
                          <option value="Swaziland">Swaziland</option>
                          <option value="Sweden">Sweden</option>
                          <option value="Switzerland">Switzerland</option>
                          <option value="Syrian Arab Republic">
                            Syrian Arab Republic
                          </option>
                          <option value="Taiwan">Taiwan</option>
                          <option value="Tajikistan">Tajikistan</option>
                          <option value="Tanzania, United Republic of">
                            Tanzania, United Republic of
                          </option>
                          <option value="Thailand">Thailand</option>
                          <option value="Timor-leste">Timor-leste</option>
                          <option value="Togo">Togo</option>
                          <option value="Tokelau">Tokelau</option>
                          <option value="Tonga">Tonga</option>
                          <option value="Trinidad and Tobago">
                            Trinidad and Tobago
                          </option>
                          <option value="Tunisia">Tunisia</option>
                          <option value="Turkey">Turkey</option>
                          <option value="Turkmenistan">Turkmenistan</option>
                          <option value="Turks and Caicos Islands">
                            Turks and Caicos Islands
                          </option>
                          <option value="Tuvalu">Tuvalu</option>
                          <option value="Uganda">Uganda</option>
                          <option value="Ukraine">Ukraine</option>
                          <option value="United Arab Emirates">
                            United Arab Emirates
                          </option>
                          <option value="United Kingdom">United Kingdom</option>
                          <option value="United States">United States</option>
                          <option value="United States Minor Outlying Islands">
                            United States Minor Outlying Islands
                          </option>
                          <option value="Uruguay">Uruguay</option>
                          <option value="Uzbekistan">Uzbekistan</option>
                          <option value="Vanuatu">Vanuatu</option>
                          <option value="Venezuela">Venezuela</option>
                          <option value="Viet Nam">Viet Nam</option>
                          <option value="Virgin Islands, British">
                            Virgin Islands, British
                          </option>
                          <option value="Virgin Islands, U.S.">
                            Virgin Islands, U.S.
                          </option>
                          <option value="Wallis and Futuna">
                            Wallis and Futuna
                          </option>
                          <option value="Western Sahara">Western Sahara</option>
                          <option value="Yemen">Yemen</option>
                          <option value="Zambia">Zambia</option>
                          <option value="Zimbabwe">Zimbabwe</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleUpdateMerchantProfileSettings}
                  disabled={this.state.btnUpdateSetting}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2"
                  onClick={() => {
                    this.setState({ showMerchantSettingsModal: false });
                  }}
                >
                  Cancel
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showTaxModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Tax Document</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ml-4">
                <div className="form-group">
                  <label>EIN*</label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter EIN "
                    defaultValue={this.state.ein}
                    onChange={(e) => {
                      this.setState({ ein: e.target.value });
                    }}
                  />
                </div>
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>Website</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Website "
                      defaultValue={this.state.website}
                      onChange={(e) => {
                        this.setState({ website: e.target.value });
                      }}
                      onBlur={this.isValidWebsite}
                    />
                    {this.state.isWebsiteError && (
                      <small className="text-danger">
                        Please insert valid website name
                      </small>
                    )}
                  </div>
                )}
                <div className="form-group">
                  <label>Please select EIN issuance document</label>
                  <input
                    type="file"
                    className="form-control"
                    defaultValue={this.state.einDoc}
                    onChange={(e) => {
                      this.setState({ einDoc: e.target.files[0] });
                    }}
                    placeholder="Select EIN Document"
                  />
                </div>
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>
                      Principal/Director/Owner's Photo Identification
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.ownerIdentityDoc}
                      onChange={(e) => {
                        this.setState({ ownerIdentityDoc: e.target.files[0] });
                      }}
                      placeholder="Select Identity Document"
                    />
                  </div>
                )}
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>
                      Incorporation documents/ Business Registration
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.inCorpDoc}
                      onChange={(e) => {
                        this.setState({ inCorpDoc: e.target.files[0] });
                      }}
                      placeholder="Select Incorporation Document"
                    />
                  </div>
                )}
                {this.state.selectedPlanIdForApply == "3" && (
                  <div className="form-group">
                    <label>Proof of Business Address</label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.inCorpDoc}
                      onChange={(e) => {
                        this.setState({
                          businessAddressDoc: e.target.files[0],
                        });
                      }}
                      placeholder="Select Proof of Business Address"
                    />
                  </div>
                )}
                <div className="row">
                  <div className="">
                    <button
                      className="btn btn-primary"
                      onClick={this.handleApplyPlan}
                      disabled={this.state.btnDisabled}
                    >
                      Apply
                    </button>
                  </div>
                  <div className="ml-2">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        this.setState({
                          showTaxModal: false,
                          showIncreaseVolumeModal: true,
                        });
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showChangePasswordAuthModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title> Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your google authenticator</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Google Authentication code"
                    ref={this.changePasswordAuthCodeRef}
                    value={this.state.changePasswordAuthCode}
                    onChange={function (e) {
                      this.setState({
                        changePasswordAuthCode: e.target.value,
                        isChangePswdAuthCodeBtn:
                          !this.state.isChangePswdAuthCodeBtn,
                      });
                    }.bind(this)}
                    onKeyUp={function (e) {
                      let elmVal = e.target.value;
                      let regex = /^[0-9]{6,6}$/;
                      if (regex.test(elmVal)) {
                        this.setState({ isChangePswdAuthCodeBtn: false });
                      } else {
                        this.setState({ isChangePswdAuthCodeBtn: true });
                      }
                    }.bind(this)}
                  />
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.isPasswordAuthCheck}
                    disabled={this.state.isChangePswdAuthCodeBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        showChangePasswordAuthModal: false,
                        changePasswordAuthCode: "",
                      });
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.changePhnoModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Change Phone Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group mb-2">
                  <label>
                    Input otp from your <b>registered phone number</b>
                  </label>
                  <p>
                    We sent a text message to you at{" "}
                    {localStorage.getItem(SITENAMEALIAS + "_registredphno")}.
                    Enter the seven digit code in that message to confirm your
                    phone number.
                  </p>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.registeredPhnoOtpRef}
                        value={this.state.registeredPhnoOtp}
                        onChange={(e) => {
                          this.setState({ registeredPhnoOtp: e.target.value });
                        }}
                      />
                    </div>
                    <div className="col-md-4 pl-0">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendOtpToRegNo}
                        disabled={this.state.sendOtpOldNo}
                      >
                        Send
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showTimerForChangPhno && (
                        <p className="text-center">
                          Resend Otp in {this.state.otptimertxt}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.verifyChangeNo}
                    disabled={this.state.btnProceedToNewNo}
                  >
                    Proceed
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({
                        changePhnoModal: !this.state.changePhnoModal,
                      });
                      this.registeredPhnoOtpRef.current.value = "";
                      localStorage.setItem("cdotpforchangephno", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.newPhnoModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Change Phone Number</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group mb-2">
                  <label>
                    Input otp from your <b>New phone number</b>
                  </label>
                  <p>
                    We sent a text message to you at {this.state.phoneNo}. Enter
                    the seven digit code in that message to confirm your phone
                    number.
                  </p>
                  <div className="row">
                    <div className="col-md-8">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.newPhnoOtpRef}
                      />
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendOtpToNewNo}
                        disabled={this.state.sendOtpInNewnoBtn}
                      >
                        Send
                      </button>
                    </div>
                    <div className="col-md-12 mt-2">
                      {this.state.isTimerShow2 && (
                        <p className="text-center">
                          Resend Otp in {this.state.timertxt2}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.updateNewNo}
                    disabled={this.state.btnUpdateToNewNo}
                  >
                    Proceed
                  </button>
                  <button
                    type="but ton"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({ newPhnoModal: !this.state.newPhnoModal });
                      this.newPhnoOtpRef.current.value = "";
                      localStorage.setItem("cdotpfornewphno", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.emailUpdateOtpModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="d-flex justify-content-center">
              <Modal.Title>Update Email Address</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <p>
                  We have sent OTP to both your current email (
                  <b>{localStorage.getItem(SITENAMEALIAS + "_email")}</b>) and
                  new email (<b>{this.state.newEmailForUpdate}</b>). Please
                  enter the codes below to verify.
                </p>
                <div className="form-group mb-3">
                  <label>
                    Input OTP from your <b>current email address</b>
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter OTP from current email"
                        ref={this.oldEmailOtpRef}
                        onChange={(e) => {
                          let reg = /^\d{7}$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ oldEmailOtp: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ oldEmailOtp: e.target.value });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label>
                    Input OTP from your <b>new email address</b>
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter OTP from new email"
                        ref={this.newEmailOtpRef}
                        onChange={(e) => {
                          let reg = /^\d{7}$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ newEmailOtp: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ newEmailOtp: e.target.value });
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12 pl-0">
                  {this.state.showOldEmailOtpTimer && (
                    <p className="text-center">
                      OTP Sent · Resend in {this.state.oldEmailOtpTimerTxt}s
                    </p>
                  )}
                  {!this.state.showOldEmailOtpTimer && (
                    <p className="text-center">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={this.resendEmailUpdateOtp}
                        disabled={this.state.sendOtpOldEmailBtn}
                      >
                        Resend OTP
                      </button>
                    </p>
                  )}
                </div>
                <div
                  className="form-group col-12 pl-0 mb-2"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.submitEmailUpdateOtp}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2"
                    onClick={() => {
                      this.setState({ emailUpdateOtpModal: false });
                      this.oldEmailOtpRef.current.value = "";
                      this.newEmailOtpRef.current.value = "";
                      localStorage.setItem("cdotpforemailupdate", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.showVerifyOtpModalWhilePhoneAuthDisable}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>SMS Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label className="text-center">
                    Input OTP from google authentication app
                  </label>
                  <div className="row">
                    <div className="col-md-8">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.googleAuthOtpRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.googleAuthVerify}
                  >
                    Confirm
                  </button>
                  <button type="but ton" className="btn btn-secondary ml-2  ">
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.twoFaSendEmailOtpModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your registered email address</label>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        title="Input must be 7 digits only"
                        defaultValue={this.state.emailOtpFor2fa}
                        ref={this.emailOtpFor2faRef}
                        onChange={(e) => {
                          let reg = /^\d{7}$/;
                          if (e.target.value.match(reg)) {
                            this.setState({ emailOtpFor2fa: e.target.value });
                          } else {
                            e.target.value = e.target.value.slice(0, -1);
                            this.setState({ emailOtpFor2fa: e.target.value });
                          }
                        }}
                      />
                      {this.state.emailOtpFor2faRefError && (
                        <small className="text-danger">
                          {this.state.emailOtpFor2faRefError}
                        </small>
                      )}
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendEmailFor2fa}
                        disabled={this.state.sendEmailOtpBtn}
                      >
                        Send OTP
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showEmailOtpTimer && (
                        <p className="text-center">
                          Resend Otp in {this.state.emailOtpTimerTxt}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.submit2faEmailOtp}
                    disabled={this.state.proceedEmailOtpBtn}
                  >
                    Proceed
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 "
                    onClick={() => {
                      this.setState({ twoFaSendEmailOtpModal: false });
                      this.state.emailOtpFor2faRef = "";
                      localStorage.setItem("cdotpforemail2fa", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.scannerModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header className="px-4">
              <Modal.Title>Google Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="p-3">
                <div className="row form-group">
                  <div className="col-md-12">
                    <h4 className="text-center mb-3">
                      Please do not click the back button or reload the page
                    </h4>
                  </div>
                  <div
                    className="col-md-12"
                    style={{
                      height: "auto",
                      margin: "10px auto",
                      maxWidth: 250,
                      width: "100%",
                    }}
                  >
                    <QRCode
                      size={256}
                      style={{
                        height: "auto",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      value={this.state.qrCodeValFor2fa}
                      viewBox={`0 0 256 256`}
                    />
                  </div>
                  <div className="col-md-12">
                    <p>Save this emergency recovery key</p>
                    <p>
                      If you loose access to your phone, you won't be able to
                      log in to your account without this key. Print, copy or
                      write down this key without letting anyone see it.
                    </p>
                    <p>Seriously, save this key!</p>
                  </div>
                  <div className="col-md-12 pl-0">
                    <div className="row">
                      <div className="col-md-9">
                        <p className="mt-2">
                          <b ref={this.copyTxtRef}>
                            {this.state.googleAuthKey}
                          </b>
                        </p>
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-primary"
                          onClick={this.copyTextToClipboard}
                        >
                          Copy
                        </button>
                      </div>
                      <div className="col-md-1"></div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="row mt-3">
                      <div className="col-md-12">
                        <input
                          type="password"
                          value={this.state.qrcodeval}
                          className="form-control mb-3"
                          ref={this.twofaqrcodevalue}
                          placeholder="Google Authentication Code"
                          onChange={(e) => {
                            var regex = /^[0-9\b]+$/;
                            if (
                              e.target.value === "" ||
                              regex.test(e.target.value)
                            ) {
                              this.setState({
                                qrcodeval: e.target.value,
                                verifyQrCodeBtn: false,
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-md-12">
                        <center>
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={this.state.verifyQrCodeBtn}
                            onClick={this.getTwoFactorAuthVerifcation}
                          >
                            Submit
                          </button>
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.twoFactorDisableModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <form className="forms-sample">
                <div className="form-group">
                  <label>Input otp from your registered email address</label>
                  <div className="row">
                    <div className="col-md-8 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="OTP"
                        ref={this.emailOtpForTwoFaOff}
                      />
                    </div>
                    <div className="col-md-4">
                      <button
                        type="button"
                        className="btn btn-primary mt-1"
                        onClick={this.sendEmailFor2fa}
                        disabled={this.state.sendEmailOtpFor2faBtn}
                      >
                        {this.state.sendEmailOtpFor2faBtn
                          ? "OTP Sent"
                          : "Resend OTP"}
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.state.showEmailOtpTimer && (
                        <p className="text-center">
                          Resend Otp in {this.state.emailOtpTimerTxt}s
                        </p>
                      )}
                    </div>
                  </div>
                  <br />
                  <label>
                    Input otp from your{" "}
                    {localStorage.getItem(SITENAMEALIAS + "_exchange")} Google
                    Authenticator
                  </label>
                  <div className="row">
                    <div className="col-md-12 pl-0">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Two-Factor Authentication Code"
                        ref={this.gaCodeFor2faOff}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group col-12 pl-0">
                  <button
                    type="but ton"
                    className="btn btn-primary"
                    onClick={this.saveTwoFactorSettingOff}
                    disabled={this.state.proceedEmailOtpBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary ml-2 "
                    onClick={() => {
                      this.setState({ twoFactorDisableModal: false });
                      this.state.emailOtpForTwoFaOff = "";
                      this.state.gaCodeFor2faOff = "";
                      localStorage.setItem("cdotpforemail2fa", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal.Body>
          </Modal>

          <Modal
            show={this.state.twoFactorAPIKeyModal}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Security Authentication</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>Input otp from your registered email address</label>
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-md-8 pl-0">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="OTP"
                      ref={this.emailOtpForTwoFaOff}
                    />
                  </div>
                  <div className="col-md-4">
                    <button
                      type="button"
                      className="btn btn-primary mt-1"
                      onClick={this.sendEmailFor2fa}
                      disabled={this.state.sendEmailOtpFor2faBtn}
                    >
                      {this.state.sendEmailOtpFor2faBtn
                        ? "OTP Sent"
                        : "Resend OTP"}
                    </button>
                  </div>
                  <div className="col-md-12">
                    {this.state.showEmailOtpTimer && (
                      <p className="text-center" style={{ paddingTop: "15px" }}>
                        Resend Otp in {this.state.emailOtpTimerTxt}s
                      </p>
                    )}
                  </div>
                </div>
                <label style={{ paddingTop: "10px" }}>
                  Input otp from your{" "}
                  {localStorage.getItem(SITENAMEALIAS + "_exchange")} Google
                  Authenticator
                </label>
                <div className="row">
                  <div className="col-md-12 pl-0">
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Two-Factor Authentication Code"
                      ref={this.gaCodeFor2faOff}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group col-12 pl-0">
                <button
                  type="but ton"
                  className="btn btn-primary"
                  onClick={() => {
                    if (this.state.twoFactorAPIKeyModalStatus === "Create") {
                      this.createAPIkey();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "Edit") {
                      this.updateApiKey();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "Delete") {
                      this.deleteApiKeyById();
                    }
                    if (this.state.twoFactorAPIKeyModalStatus === "DeleteAll") {
                      this.deleteApiKey();
                    }
                  }}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2 "
                  onClick={() => {
                    this.setState({ twoFactorAPIKeyModal: false });
                    this.state.emailOtpForTwoFaOff = "";
                    this.state.gaCodeFor2faOff = "";
                    localStorage.setItem("cdotpforemail2fa", "");
                  }}
                >
                  Cancel
                </button>
              </div>
            </Modal.Body>
          </Modal>

          <Loader show={this.state.showLoader} />
          <PaybitoCaptcha ref={this.basicSettingRecaptchaRef} sitekey={CAPTCHASITEKEY} />
          <PaybitoCaptcha ref={this.passwordChangeRecaptchaRef} sitekey={CAPTCHASITEKEY} />
          <PaybitoCaptcha ref={this.deleteRecaptchaRef} sitekey={CAPTCHASITEKEY} />
        </div>
      </Fragment>
    );
  }
}

export default BussinessSettings;
